<template>
  <div ref="rootRef" class="hm-care-orders">
  <div class="page-title-bar">
    <h1 class="page-title">HomeMetric Care Orders</h1>
  </div>
  <div class="order-page">
    <div class="orders-page-head">
      <div class="order-top-bar">
        <!-- group_1 筛选栏 -->
        <div class="filter-wrapper filter-group_1">
          <!-- box_55 第一行：Order ID / 日期 / Service Status -->
          <div class="filter-row filter-row-primary filter-box_55">
            <div
              class="filter-row-primary-inputs"
              :class="{ 'filter-row-primary-inputs--fu': isFuSpecialFilterView || isPendSubFilterView }"
            >
              <div class="filter-item order-id-item has-dropdown">
                <span
                  role="button"
                  tabindex="0"
                  class="field-type-btn"
                  @click="toggleDd('field')"
                  @keydown.enter.prevent="toggleDd('field')"
                  @keydown.space.prevent="toggleDd('field')"
                >
                  <span class="label">{{ searchFieldLabels[form.searchField] }}</span>
                  <img :src="imgDown" class="icon downarrow-inline" alt="" />
                </span>
                <span class="field-split" />
                <input
                  :value="form.searchQuery"
                  type="text"
                  placeholder="Search.."
                  @input="onSearchQueryInput"
                  @paste="onSearchQueryPaste"
                  @keydown.enter.prevent="runSearch"
                  @focus="openDd = null"
                />
                <ul v-if="openDd === 'field'" class="dropdown-panel">
                  <li
                    v-for="key in searchFieldKeys"
                    :key="key"
                    :class="{ active: form.searchField === key }"
                    @click="selectSearchField(key)"
                  >
                    {{ searchFieldLabels[key] }}
                  </li>
                </ul>
              </div>

              <div class="filter-item date-wrapper has-dropdown">
                <div class="date-calendar-anchor">
                  <div class="date-item-box">
                    <span class="label">{{ isFuPendingRescheduleView ? 'Inspection Date:' : 'Service Date:' }}</span>
                    <input
                      :value="form.serviceDate"
                      type="text"
                      readonly
                      placeholder="Select a date"
                      @click="openCalKey('service')"
                    />
                    <span class="date-cal-split" aria-hidden="true" />
                    <img
                      :src="imgCal"
                      class="calendar-icon-inline"
                      alt=""
                      @click.stop="openCalKey('service')"
                    />
                  </div>
                  <div v-if="openCal === 'service'" class="calendar-pop">
                    <CalendarMini
                      v-model:month="calMonthSvc"
                      v-model:year="calYearSvc"
                      :selected-ymd="form.serviceDate"
                      @pick="onPickDate('service', $event)"
                    />
                  </div>
                </div>
              </div>

              <div class="filter-item date-wrapper has-dropdown">
                <div class="date-calendar-anchor">
                  <div class="date-item-box">
                    <span class="label">Follow-up Date:</span>
                    <input
                      :value="form.followUpDate"
                      type="text"
                      readonly
                      placeholder="Select a date"
                      @click="openCalKey('followup')"
                    />
                    <span class="date-cal-split" aria-hidden="true" />
                    <img
                      :src="imgCal"
                      class="calendar-icon-inline"
                      alt=""
                      @click.stop="openCalKey('followup')"
                    />
                  </div>
                  <div v-if="openCal === 'followup'" class="calendar-pop">
                    <CalendarMini
                      v-model:month="calMonthFu"
                      v-model:year="calYearFu"
                      :selected-ymd="form.followUpDate"
                      @pick="onPickDate('followup', $event)"
                    />
                  </div>
                </div>
              </div>

              <div class="filter-item select-item has-dropdown service-status-item">
                <span class="label">Service Status:</span>
                <input
                  :value="serviceStatusDisplay"
                  type="text"
                  readonly
                  :class="{ 'filter-select-placeholder': form.serviceStatus === 'all' }"
                  @click="toggleDd('status')"
                />
                <img :src="imgDown" class="icon downarrow" alt="" />
                <ul v-if="openDd === 'status'" class="dropdown-panel">
                  <li
                    v-for="s in serviceStatusMenuOptions"
                    :key="s.value"
                    :class="{ active: form.serviceStatus === s.value }"
                    @click="selectStatus(s.value)"
                  >
                    {{ s.label }}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- box_56 第二行：Technician / Search / Clear（与上行同列栅格，Search–Clear 间距 16px） -->
          <div
            class="filter-row-bottom filter-box_56"
            :class="{ 'filter-box_56--fu': isFuSpecialFilterView || isPendSubFilterView }"
          >
            <template v-if="isFuSpecialFilterView || isPendSubFilterView">
              <div class="filter-item select-item insp-item has-dropdown">
                <span class="label">Inspector:</span>
                <input
                  :value="inspectorLabel"
                  type="text"
                  readonly
                  :class="{ 'filter-select-placeholder': form.inspectorId === 'All' }"
                  @click="toggleDd('insp')"
                />
                <img :src="imgDown" class="icon downarrow" alt="" />
                <ul v-if="openDd === 'insp'" class="dropdown-panel">
                  <li
                    :class="{ active: form.inspectorId === 'All' }"
                    @click="selectInspector('All', 'All')"
                  >
                    All
                  </li>
                  <li
                    v-for="t in technicians"
                    :key="`insp-${t.id}`"
                    :class="{ active: form.inspectorId === t.id }"
                    @click="selectInspector(t.id, t.name)"
                  >
                    {{ t.name }}
                  </li>
                </ul>
              </div>
            </template>
            <div class="filter-item select-item tech-item has-dropdown">
              <span class="label">Technician:</span>
              <input
                :value="technicianLabel"
                type="text"
                readonly
                :class="{ 'filter-select-placeholder': form.technicianId === 'All' }"
                @click="toggleDd('tech')"
              />
              <img :src="imgDown" class="icon downarrow" alt="" />
              <ul v-if="openDd === 'tech'" class="dropdown-panel">
                <li
                  :class="{ active: form.technicianId === 'All' }"
                  @click="selectTechnician('All', 'All')"
                >
                  All
                </li>
                <li
                  v-for="t in technicians"
                  :key="t.id"
                  :class="{ active: form.technicianId === t.id }"
                  @click="selectTechnician(t.id, t.name)"
                >
                  {{ t.name }}
                </li>
              </ul>
            </div>
            <div class="btn-group">
              <button type="button" class="search-btn" :disabled="loading" @click="runSearch">
                Search
              </button>
              <button type="button" class="clear-btn" @click="clearFilters">Clear</button>
            </div>
          </div>
        </div>
      </div>

      <!-- box_57：1164 宽，距 group_1 底 12px -->
      <div class="order-meta-row order-stats-box_57">
        <span class="order-count" :class="{ 'order-count--pending': loading }">
          <template v-if="isFuPendingScheduleView || isPendScheduleView || isPendRescheduleView">
            {{ orderListCount }} {{ orderListCount === 1 ? 'Order' : 'Orders' }}
          </template>
          <template v-else>{{ orderListCount }} Orders</template>
        </span>
        <button
          v-if="!isFuPendingRescheduleView && !isFuPendingScheduleView && !isPendScheduleView && !isPendRescheduleView"
          type="button"
          class="new-btn"
          @click="goNewOrderPage"
        >
          + NEW
        </button>
      </div>

    </div>

    <div ref="ordersBodyRef" class="orders-body">
      <div class="orders-list" :aria-busy="loading">
        <LoadingIndicator v-if="loading" />
        <div v-else-if="!pagedOrders.length" class="orders-empty">
          <img :src="imgListBlank" class="orders-empty-img" alt="" />
          <p class="orders-empty-msg">No items found</p>
        </div>
        <template v-else>
          <article
            v-for="order in pagedOrders"
            :key="order.id"
            class="order-card"
            :class="{
              'order-card--has-notes': orderShowsNotesBanner(order),
            }"
          >
          <header class="card-head group_10">
            <span class="head-cell head-cell-id">
              <span class="head-label">Order ID:</span>
              <span class="head-value">{{ order.id }}</span>
            </span>
            <span class="head-cell head-cell-home">
              <span class="head-label">User ID:</span>
              <span class="head-value">{{ order.homeId }}</span>
            </span>
            <span class="head-cell head-cell-status">
              <span class="head-label">Service Status:</span>
              <span class="head-value">{{ orderCardHeadServiceStatusDisplay(order) }}</span>
            </span>
            <span class="head-cell head-cell-date">
              <span class="head-label">Placed on:</span>
              <span class="head-value">{{ order.placementDate }}</span>
            </span>
          </header>
          <template v-if="orderUsesMergedAssignPayLayout(order)">
            <div class="card-body card-body--merged-split">
              <div
                v-for="idx in MERGED_SVC_INDEXES"
                :key="`${order.id}-m-svc-${idx}`"
                :class="['merged-svc', idx === 0 ? 'merged-svc--0' : 'merged-svc--1', 'col', 'col-service']"
              >
                              <div v-if="showServiceLineIcon(mergedCareLine(order, idx))" class="svc-icon-wrap">
                                <img :src="imgHmGreen" class="svc-hex" alt="" />
                              </div>
                              <div v-else class="svc-icon-spacer" aria-hidden="true"></div>
                              <div class="svc-stack">
                                <div class="svc-name">{{ mergedCareLine(order, idx).serviceName }}</div>
                                <div
                                  v-if="
                                    shouldShowMainLineInspectionTags(order) &&
                                    !isFollowUpCareLine(mergedCareLine(order, idx)) &&
                                    productCodeTagParts(mainLineInspectionProductCodeDisplay(order, mergedCareLine(order, idx))).length
                                  "
                                  class="svc-tags"
                                >
                                  <template
                                    v-for="(part, ti) in productCodeTagParts(
                                      mainLineInspectionProductCodeDisplay(order, mergedCareLine(order, idx)),
                                    )"
                                    :key="ti"
                                  >
                                    <span v-if="ti > 0" class="svc-tag-sep" aria-hidden="true"></span>
                                    <span :class="['svc-tag', tagToneClass(part)]">{{ part }}</span>
                                  </template>
                                </div>
                                <div
                                  v-else-if="
                                    shouldShowMainLineInspectionTags(order) &&
                                    !isFollowUpCareLine(mergedCareLine(order, idx)) &&
                                    mainLineInspectionProductCodeDisplay(order, mergedCareLine(order, idx)).trim()
                                  "
                                  class="svc-code"
                                >
                                  {{ mainLineInspectionProductCodeDisplay(order, mergedCareLine(order, idx)) }}
                                </div>
                                <div class="svc-time-stack">
                                  <template v-if="followUpRowShowsPreferredRescheduleBlock(order, mergedCareLine(order, idx))">
                                    <div class="svc-time-row">
                                      <span
                                        class="svc-time"
                                        :class="{
                                          'svc-time--pending-schedule': isPendingTimePlaceholderDisplay(
                                            mergedCareLine(order, idx),
                                            order,
                                          ),
                                        }"
                                      >{{
                                        formatSvcTimeDisplay(mergedCareLine(order, idx), order)
                                      }}</span>
                                      <PreferredTimeTipHost :entries="orderPreferredTimeTipEntries(order)">
                                        <button type="button" class="fu-preferred-time-btn" aria-label="Preferred times">
                                          <img :src="serviceTimeStatusIconSrc(order, mergedCareLine(order, idx))" class="svc-time-status-ic" alt="" />
                                        </button>
                                      </PreferredTimeTipHost>
                                    </div>
                                  </template>
                                  <template v-else-if="mainLineRowShowsPendingReschedulePreferredBlock(order, mergedCareLine(order, idx))">
                                    <div class="svc-time-row">
                                      <span
                                        class="svc-time"
                                        :class="{
                                          'svc-time--pending-schedule': isPendingTimePlaceholderDisplay(
                                            mergedCareLine(order, idx),
                                            order,
                                          ),
                                        }"
                                      >{{
                                        formatSvcTimeDisplay(mergedCareLine(order, idx), order)
                                      }}</span>
                                      <PreferredTimeTipHost :entries="orderPreferredTimeTipEntries(order)">
                                        <button type="button" class="fu-preferred-time-btn" aria-label="Preferred times">
                                          <img :src="serviceTimeStatusIconSrc(order, mergedCareLine(order, idx))" class="svc-time-status-ic" alt="" />
                                        </button>
                                      </PreferredTimeTipHost>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <div class="svc-time-row">
                                      <span
                                        class="svc-time"
                                        :class="{
                                          'svc-time--pending-schedule': isPendingTimePlaceholderDisplay(
                                            mergedCareLine(order, idx),
                                            order,
                                          ),
                                        }"
                                      >
                                        {{ formatSvcTimeDisplay(mergedCareLine(order, idx), order) }}
                                      </span>
                                      <template
                                        v-if="lineShowsServiceTimeStatusIcon(mergedCareLine(order, idx), order)"
                                      >
                                        <PreferredTimeTipHost
                                          v-if="
                                            lineShowsPreferredTimeTooltip(mergedCareLine(order, idx), order)
                                          "
                                          :entries="
                                            linePreferredTimeTipEntries(order, mergedCareLine(order, idx))
                                          "
                                        >
                                          <button
                                            type="button"
                                            class="fu-preferred-time-btn"
                                            aria-label="Preferred times"
                                          >
                                            <img
                                              :src="serviceTimeStatusIconSrc(order, mergedCareLine(order, idx))"
                                              class="svc-time-status-ic"
                                              alt=""
                                            />
                                          </button>
                                        </PreferredTimeTipHost>
                                        <button
                                          v-else
                                          type="button"
                                          class="fu-preferred-time-btn"
                                          aria-label="Schedule status"
                                          tabindex="-1"
                                        >
                                          <img
                                            :src="serviceTimeStatusIconSrc(order, mergedCareLine(order, idx))"
                                            class="svc-time-status-ic"
                                            alt=""
                                          />
                                        </button>
                                      </template>
                                    </div>
                                  </template>
                                </div>
                                <div class="svc-addr">{{ mergedCareLine(order, idx).address }}</div>
                              </div>
              </div>
              <div
                class="merged-assign-top col col-assign"
                role="group"
                :aria-label="
                  mergedMainLine(order).technicianRef
                    ? `Technician ${mergedMainLine(order).assignment}. Staff ID ${formatTechnicianRefDisplay(mergedMainLine(order).technicianRef, mergedMainLine(order).assignment)}. Confirmed.`
                    : (mergedMainLine(order).assignment || 'Pending assignment')
                "
              >
                <template v-if="mergedMainLine(order).technicianRef">
                  <AssignNameTipHost :text="mergedMainLine(order).assignment">
                    <span class="assign-name">{{ mergedMainLine(order).assignment }}</span>
                  </AssignNameTipHost>
                  <AssignNameTipHost
                    :text="technicianRefView(mergedMainLine(order).technicianRef, mergedMainLine(order).assignment).tipText"
                    placement="bottom"
                    class="assign-ref-tip-host"
                  >
                    <span class="assign-ref">
                      <img :src="imgNormal" class="assign-ref-icon" alt="" aria-hidden="true" />{{ technicianRefView(mergedMainLine(order).technicianRef, mergedMainLine(order).assignment).display }}
                    </span>
                  </AssignNameTipHost>
                </template>
                <span v-else class="assign-pending">
                  <template v-if="isPendingAssignmentLabel(mergedMainLine(order).assignment)">
                    <span class="assign-pending-line">Pending</span>
                    <span class="assign-pending-line">Assignment</span>
                  </template>
                  <template v-else>{{ mergedMainLine(order).assignment }}</template>
                </span>
              </div>
              <div
                class="merged-assign-bottom col col-assign"
                role="group"
                :aria-label="mergedFollowUpAssignBottomAriaLabel(order)"
              >
                <template v-if="mergedFollowUpAssignShowsPending(order)">
                  <span class="assign-pending assign-pending--fu-merge">
                    <span class="assign-pending-line">Pending</span>
                    <span class="assign-pending-line">Assignment</span>
                  </span>
                </template>
                <template v-else-if="mergedFollowUpLine(order).technicianRef">
                  <AssignNameTipHost :text="mergedFollowUpLine(order).assignment">
                    <span class="assign-name assign-name--fu-merge">{{ mergedFollowUpLine(order).assignment }}</span>
                  </AssignNameTipHost>
                </template>
                <span v-else class="assign-pending">
                  <template v-if="isPendingAssignmentLabel(mergedFollowUpLine(order).assignment)">
                    <span class="assign-pending-line">Pending</span>
                    <span class="assign-pending-line">Assignment</span>
                  </template>
                  <template v-else>
                    <AssignNameTipHost :text="mergedFollowUpLine(order).assignment">
                      <span class="assign-name assign-name--fu-merge">{{ mergedFollowUpLine(order).assignment }}</span>
                    </AssignNameTipHost>
                  </template>
                </span>
              </div>
              <div
              class="merged-pay col col-pay col-pay--merged"
              role="group"
              :aria-label="`Amount due ${mergedMainLine(order).price}. Payment method: ${mergedMainLine(order).paymentMethod}.${mergedMainLine(order).discount ? ' ' + mergedMainLine(order).discount + '.' : ''}`"
              >
              <div class="price">{{ mergedMainLine(order).price }}</div>
              <div class="pay-divider" aria-hidden="true"></div>
              <div class="pay-method">{{ mergedMainLine(order).paymentMethod }}</div>
              <div
                v-if="mergedMainLine(order).paymentDue"
                class="pay-due-badge"
              >Payment Due</div>
              <div v-if="mergedMainLine(order).discount" class="discount">{{ mergedMainLine(order).discount }}</div>
              </div>
              <div class="merged-detail col col-detail col-detail--merged">
              <a href="#" class="link" @click.stop.prevent="openOrderDetail(order)">View Details</a>
              </div>
              <div class="merged-actions col col-actions col-actions--merged">
              <template v-if="orderUsesRescheduleActionMenu(order)">
              <button
              type="button"
              class="action"
              :class="{ disabled: lineRescheduleDisabled(order, mergedScheduleActionTarget(order).line, mergedScheduleActionTarget(order).lineIndex) }"
              :disabled="lineRescheduleDisabled(order, mergedScheduleActionTarget(order).line, mergedScheduleActionTarget(order).lineIndex)"
              @click.stop="onLineAction(order, mergedScheduleActionTarget(order).line, mergedScheduleActionTarget(order).lineIndex, 'schedule')"
              >
              <img :src="imgSchedule" class="action-ic" alt="" />
              Reschedule
              </button>
              <button
              type="button"
              class="action"
              @click.stop="onLineAction(order, mergedMainLine(order), 0, 'refund')"
              >
              <img :src="imgRefund" class="action-ic" alt="" />
              Refund
              </button>
              <button
              type="button"
              class="action action--stub"
              @click.stop="onLineAction(order, mergedMainLine(order), 0, 'message')"
              >
              <img :src="imgMessage" class="action-ic" alt="" />
              Send Messages
              </button>
              </template>
              <template v-else-if="orderUsesRescheduleWithNotesActionMenu(order)">
              <button
              type="button"
              class="action"
              :class="{ disabled: lineRescheduleDisabled(order, mergedScheduleActionTarget(order).line, mergedScheduleActionTarget(order).lineIndex) }"
              :disabled="lineRescheduleDisabled(order, mergedScheduleActionTarget(order).line, mergedScheduleActionTarget(order).lineIndex)"
              @click.stop="onLineAction(order, mergedScheduleActionTarget(order).line, mergedScheduleActionTarget(order).lineIndex, 'schedule')"
              >
              <img :src="imgSchedule" class="action-ic" alt="" />
              Reschedule
              </button>
              <button
              type="button"
              class="action"
              @click.stop="onLineAction(order, mergedMainLine(order), 0, 'refund')"
              >
              <img :src="imgRefund" class="action-ic" alt="" />
              Refund
              </button>
              <button
              type="button"
              class="action action--stub"
              @click.stop="onLineAction(order, mergedMainLine(order), 0, 'message')"
              >
              <img :src="imgMessage" class="action-ic" alt="" />
              Send Messages
              </button>
              <button
              v-if="orderShowsAddNotesAction(order)"
              type="button"
              class="action"
              :class="{ disabled: !lineAllowsNoteAction(order, mergedMainLine(order), 0) || isLineActionBusy(order.id, 0) }"
              :disabled="!lineAllowsNoteAction(order, mergedMainLine(order), 0) || isLineActionBusy(order.id, 0)"
              @click.stop="onLineAction(order, mergedMainLine(order), 0, 'note')"
              >
              <img :src="imgNote" class="action-ic" alt="" />
              Add notes
              </button>
              </template>
              <template v-else>
              <button
              type="button"
              class="action"
              :class="{ disabled: mergedScheduleActionDisabled(order) }"
              :disabled="mergedScheduleActionDisabled(order)"
              @click.stop="onLineAction(order, mergedScheduleActionTarget(order).line, mergedScheduleActionTarget(order).lineIndex, 'schedule')"
              >
              <img :src="imgSchedule" class="action-ic" alt="" />
              Schedule
              </button>
              <button
              type="button"
              class="action"
              @click.stop="onLineAction(order, mergedMainLine(order), 0, 'refund')"
              >
              <img :src="imgRefund" class="action-ic" alt="" />
              Refund
              </button>
              <button
              type="button"
              class="action action--stub"
              @click.stop="onLineAction(order, mergedMainLine(order), 0, 'message')"
              >
              <img :src="imgMessage" class="action-ic" alt="" />
              Send Messages
              </button>
              <button
              v-if="orderShowsAddNotesAction(order)"
              type="button"
              class="action"
              :class="{ disabled: !lineAllowsNoteAction(order, mergedMainLine(order), 0) || isLineActionBusy(order.id, 0) }"
              :disabled="!lineAllowsNoteAction(order, mergedMainLine(order), 0) || isLineActionBusy(order.id, 0)"
              @click.stop="onLineAction(order, mergedMainLine(order), 0, 'note')"
              >
              <img :src="imgNote" class="action-ic" alt="" />
              Add notes
              </button>
              </template>
              <button
              type="button"
              class="action"
              @click.stop="openOrderDeleteModal(order)"
              >
              <img :src="imgDelete" class="action-ic" alt="" />
              Delete
              </button>
              </div>
            </div>
          </template>
          <template v-else>
          <div
            v-for="(line, idx) in order.services"
            :key="line.id ?? idx"
            class="card-body"
          >
            <div class="col col-service">
              <div v-if="showServiceLineIcon(line)" class="svc-icon-wrap">
                <img :src="imgHmGreen" class="svc-hex" alt="" />
              </div>
              <div v-else class="svc-icon-spacer" aria-hidden="true"></div>
              <div class="svc-stack">
                <div class="svc-name">{{ line.serviceName }}</div>
                <div
                  v-if="
                    shouldShowMainLineInspectionTags(order) &&
                    !isFollowUpCareLine(line) &&
                    productCodeTagParts(mainLineInspectionProductCodeDisplay(order, line)).length
                  "
                  class="svc-tags"
                >
                  <template
                    v-for="(part, ti) in productCodeTagParts(mainLineInspectionProductCodeDisplay(order, line))"
                    :key="ti"
                  >
                    <span v-if="ti > 0" class="svc-tag-sep" aria-hidden="true"></span>
                    <span :class="['svc-tag', tagToneClass(part)]">{{ part }}</span>
                  </template>
                </div>
                <div
                  v-else-if="
                    shouldShowMainLineInspectionTags(order) &&
                    !isFollowUpCareLine(line) &&
                    mainLineInspectionProductCodeDisplay(order, line).trim()
                  "
                  class="svc-code"
                >
                  {{ mainLineInspectionProductCodeDisplay(order, line) }}
                </div>
                <div class="svc-time-stack">
                  <template v-if="followUpRowShowsPreferredRescheduleBlock(order, line)">
                    <div class="svc-time-row">
                      <span
                        class="svc-time"
                        :class="{ 'svc-time--pending-schedule': isPendingTimePlaceholderDisplay(line, order) }"
                      >{{ formatSvcTimeDisplay(line, order) }}</span>
                      <PreferredTimeTipHost :entries="orderPreferredTimeTipEntries(order)">
                        <button type="button" class="fu-preferred-time-btn" aria-label="Preferred times">
                          <img :src="serviceTimeStatusIconSrc(order, line)" class="svc-time-status-ic" alt="" />
                        </button>
                      </PreferredTimeTipHost>
                    </div>
                  </template>
                  <template v-else-if="mainLineRowShowsPendingReschedulePreferredBlock(order, line)">
                    <div class="svc-time-row">
                      <span
                        class="svc-time"
                        :class="{ 'svc-time--pending-schedule': isPendingTimePlaceholderDisplay(line, order) }"
                      >{{ formatSvcTimeDisplay(line, order) }}</span>
                      <PreferredTimeTipHost :entries="orderPreferredTimeTipEntries(order)">
                        <button type="button" class="fu-preferred-time-btn" aria-label="Preferred times">
                          <img :src="serviceTimeStatusIconSrc(order, line)" class="svc-time-status-ic" alt="" />
                        </button>
                      </PreferredTimeTipHost>
                    </div>
                  </template>
                  <template v-else>
                    <div class="svc-time-row">
                      <span
                        class="svc-time"
                        :class="{
                          'svc-time--pending-schedule': isPendingTimePlaceholderDisplay(line, order),
                        }"
                      >
                        {{ formatSvcTimeDisplay(line, order) }}
                      </span>
                      <template v-if="lineShowsServiceTimeStatusIcon(line, order)">
                        <PreferredTimeTipHost
                          v-if="lineShowsPreferredTimeTooltip(line, order)"
                          :entries="linePreferredTimeTipEntries(order, line)"
                        >
                          <button type="button" class="fu-preferred-time-btn" aria-label="Preferred times">
                            <img :src="serviceTimeStatusIconSrc(order, line)" class="svc-time-status-ic" alt="" />
                          </button>
                        </PreferredTimeTipHost>
                        <button
                          v-else
                          type="button"
                          class="fu-preferred-time-btn"
                          aria-label="Schedule status"
                          tabindex="-1"
                        >
                          <img :src="serviceTimeStatusIconSrc(order, line)" class="svc-time-status-ic" alt="" />
                        </button>
                      </template>
                    </div>
                  </template>
                </div>
                <div class="svc-addr">{{ line.address }}</div>
              </div>
            </div>
            <div
              class="col col-assign"
              role="group"
              :aria-label="
                line.technicianRef
                  ? `Technician ${line.assignment}. Staff ID ${formatTechnicianRefDisplay(line.technicianRef, line.assignment)}. Confirmed.`
                  : (line.assignment || 'Pending assignment')
              "
            >
              <template v-if="line.technicianRef">
                <AssignNameTipHost :text="line.assignment">
                  <span class="assign-name">{{ line.assignment }}</span>
                </AssignNameTipHost>
                <AssignNameTipHost
                  :text="technicianRefView(line.technicianRef, line.assignment).tipText"
                  placement="bottom"
                  class="assign-ref-tip-host"
                >
                  <span class="assign-ref">
                    <img :src="imgNormal" class="assign-ref-icon" alt="" aria-hidden="true" />{{ technicianRefView(line.technicianRef, line.assignment).display }}
                  </span>
                </AssignNameTipHost>
              </template>
              <span v-else class="assign-pending">
                <template v-if="isPendingAssignmentLabel(line.assignment)">
                  <span class="assign-pending-line">Pending</span>
                  <span class="assign-pending-line">Assignment</span>
                </template>
                <template v-else>{{ line.assignment }}</template>
              </span>
            </div>
            <div
              class="col col-pay"
              role="group"
              :aria-label="`Amount due ${line.price}. Payment method: ${line.paymentMethod}.${line.discount ? ' ' + line.discount + '.' : ''}`"
            >
              <div class="price">{{ line.price }}</div>
              <div class="pay-divider" aria-hidden="true"></div>
              <div class="pay-method">{{ line.paymentMethod }}</div>
              <div v-if="line.paymentDue" class="pay-due-badge">Payment Due</div>
              <div v-if="line.discount" class="discount">{{ line.discount }}</div>
            </div>
            <div class="col col-detail">
              <a href="#" class="link" @click.stop.prevent="openOrderDetail(order)">View Details</a>
            </div>
            <div class="col col-actions">
              <template v-if="orderUsesRescheduleActionMenu(order)">
                <button
                  type="button"
                  class="action"
                  :class="{ disabled: lineRescheduleDisabled(order, line, idx) }"
                  :disabled="lineRescheduleDisabled(order, line, idx)"
                  @click.stop="onLineAction(order, line, idx, 'schedule')"
                  >
                  <img :src="imgSchedule" class="action-ic" alt="" />
                  Reschedule
                </button>
                <button
                  type="button"
                  class="action"
                  @click.stop="onLineAction(order, line, idx, 'refund')"
                >
                  <img :src="imgRefund" class="action-ic" alt="" />
                  Refund
                </button>
                <button
                  type="button"
                  class="action action--stub"
                  @click.stop="onLineAction(order, line, idx, 'message')"
                >
                  <img :src="imgMessage" class="action-ic" alt="" />
                  Send Messages
                </button>
              </template>
              <template v-else-if="orderUsesRescheduleWithNotesActionMenu(order, line, idx)">
                <button
                  type="button"
                  class="action"
                  :class="{ disabled: lineRescheduleDisabled(order, line, idx) }"
                  :disabled="lineRescheduleDisabled(order, line, idx)"
                  @click.stop="onLineAction(order, line, idx, 'schedule')"
                  >
                  <img :src="imgSchedule" class="action-ic" alt="" />
                  Reschedule
                </button>
                <button
                  type="button"
                  class="action"
                  @click.stop="onLineAction(order, line, idx, 'refund')"
                >
                  <img :src="imgRefund" class="action-ic" alt="" />
                  Refund
                </button>
                <button
                  type="button"
                  class="action action--stub"
                  @click.stop="onLineAction(order, line, idx, 'message')"
                >
                  <img :src="imgMessage" class="action-ic" alt="" />
                  Send Messages
                </button>
                <button
                  v-if="orderShowsAddNotesAction(order)"
                  type="button"
                  class="action"
                  :class="{ disabled: !lineAllowsNoteAction(order, line, idx) || isLineActionBusy(order.id, idx) }"
                  :disabled="!lineAllowsNoteAction(order, line, idx) || isLineActionBusy(order.id, idx)"
                  @click.stop="onLineAction(order, line, idx, 'note')"
                >
                  <img :src="imgNote" class="action-ic" alt="" />
                  Add notes
                </button>
              </template>
              <template v-else>
                <button
                  type="button"
                  class="action"
                  :class="{ disabled: lineScheduleActionDisabled(order, line, idx) }"
                  :disabled="lineScheduleActionDisabled(order, line, idx)"
                  @click.stop="onLineAction(order, line, idx, 'schedule')"
                >
                  <img :src="imgSchedule" class="action-ic" alt="" />
                  Schedule
                </button>
                <button
                  type="button"
                  class="action"
                  @click.stop="onLineAction(order, line, idx, 'refund')"
                >
                  <img :src="imgRefund" class="action-ic" alt="" />
                  Refund
                </button>
                <button
                  type="button"
                  class="action action--stub"
                  @click.stop="onLineAction(order, line, idx, 'message')"
                >
                  <img :src="imgMessage" class="action-ic" alt="" />
                  Send Messages
                </button>
                <button
                  v-if="orderShowsAddNotesAction(order)"
                  type="button"
                  class="action"
                  :class="{ disabled: !lineAllowsNoteAction(order, line, idx) || isLineActionBusy(order.id, idx) }"
                  :disabled="!lineAllowsNoteAction(order, line, idx) || isLineActionBusy(order.id, idx)"
                  @click.stop="onLineAction(order, line, idx, 'note')"
                >
                  <img :src="imgNote" class="action-ic" alt="" />
                  Add notes
                </button>
              </template>
              <button
                v-if="idx === 0"
                type="button"
                class="action"
                @click.stop="openOrderDeleteModal(order)"
              >
                <img :src="imgDelete" class="action-ic" alt="" />
                Delete
              </button>
            </div>
          </div>
          </template>

          <div v-if="orderShowsNotesBanner(order)" class="notes-banner">
            Notes: {{ displayNotesBannerBody(order.notes!) }}
          </div>
        </article>
        </template>
      </div>

      <div class="pager-wrap" @click.stop>
        <button
          type="button"
          class="nav-btn"
          :disabled="page <= 1"
          aria-label="Previous page"
          @click="goPage(page - 1)"
        >
          <img :src="imgPagerArrow" class="nav-btn-ic nav-btn-ic--prev" alt="" />
        </button>
        <button
          v-for="p in pageButtons"
          :key="p"
          type="button"
          class="page-btn"
          :class="{ active: p === page }"
          @click="goPage(p)"
        >
          {{ p }}
        </button>
        <button
          type="button"
          class="nav-btn nav-btn--next"
          :disabled="page >= totalPages"
          aria-label="Next page"
          @click="goPage(page + 1)"
        >
          <img :src="imgPagerArrow" class="nav-btn-ic" alt="" />
        </button>
        <span class="goto-label">Go to</span>
        <input
          v-model.number="gotoVal"
          class="goto-input"
          type="number"
          min="1"
          :max="totalPages"
          @keydown.enter.prevent="goPage(gotoVal)"
        />
      </div>
    </div>

    <Teleport to="body">
      <div
        v-if="noteModalOpen"
        class="note-modal-root"
        role="presentation"
      >
        <div class="note-modal" role="dialog" aria-modal="true" aria-labelledby="note-modal-title">
          <header class="note-modal-head">
            <div class="note-modal-head-top">
              <h2 id="note-modal-title">Add Notes</h2>
              <button
                type="button"
                class="note-modal-x"
                aria-label="Close"
                :disabled="noteSaving"
                @click="closeNoteModal"
              >
                <img :src="imgClose" class="note-modal-x-ic" alt="" />
              </button>
            </div>
            <label class="note-modal-label" for="note-modal-input">Notes</label>
          </header>
          <div class="note-modal-body">
            <textarea
              id="note-modal-input"
              :value="noteDraft"
              class="note-modal-textarea"
              placeholder="Add notes"
              @input="onNoteDraftInput"
              @paste="onNoteDraftPaste"
            />
          </div>
          <footer class="note-modal-foot">
            <button
              type="button"
              class="note-modal-btn note-modal-btn-outline"
              :disabled="noteSaving"
              @click="closeNoteModal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="note-modal-btn-solid"
              :disabled="noteSaving"
              @click="confirmNoteModal"
            >
              <span class="hm-modal-btn-content" :class="{ 'hm-modal-btn-content--loading': noteSaving }">
                Submit
                <ModalButtonSpinner v-if="noteSaving" />
              </span>
            </button>
          </footer>
        </div>
      </div>

      <div v-if="orderDeleteModalOpen" class="order-delete-modal-overlay">
        <div class="order-delete-modal-container" role="dialog" aria-modal="true" aria-labelledby="order-delete-modal-title" @click.stop>
          <div class="order-delete-modal-header">
            <h2 id="order-delete-modal-title" class="order-delete-modal-title">Delete Order</h2>
            <button class="order-delete-modal-close" type="button" aria-label="Close" :disabled="orderDeleteSubmitting" @click="closeOrderDeleteModal">
              <img :src="imgClose" alt="close" class="order-delete-modal-close-ic" />
            </button>
          </div>

          <div class="order-delete-modal-body">
            <p class="order-delete-modal-message">Are you sure you want to delete this order?</p>
          </div>

          <div class="order-delete-modal-footer">
            <button class="order-delete-btn-no" type="button" :disabled="orderDeleteSubmitting" @click="closeOrderDeleteModal">No</button>
            <button class="order-delete-btn-yes" type="button" :disabled="orderDeleteSubmitting" @click="confirmOrderDelete">
              <span v-if="orderDeleteSubmitting" class="order-delete-spinner"></span>
              <span v-else>Yes</span>
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <NewCareOrder
      v-model:open="newOrderModalOpen"
      @refresh="onNewOrderRefresh"
      @local-insert="onNewOrderLocalInsert"
    />

    <RefundModal
      :visible="refundModalOpen"
      :order-primary-id="refundOrderPrimaryId"
      :line-index="refundTarget?.lineIndex ?? 0"
      :amount-paid="refundAmountPaid"
      :refundable-amount="refundableAmountDisplay"
      :refunded-amount="refundedAmountDisplay"
      :tax-rate="refundTaxRate"
      :tax-options="refundTaxOptions"
      :submitting="refundSaving"
      @close="closeRefundModal"
      @submit="confirmRefundModal"
      @toast="(payload) => emit('toast', payload)"
    />

    <Teleport to="body">
      <div
        v-if="orderDetailOverlayOrder"
        class="cod-overlay-root"
      >
        <div class="cod-overlay-shell">
          <CareOrderDetailPanel
            :order="orderDetailOverlayOrder"
            @close="closeOrderDetailOverlay"
            @orders-refresh="onOrderDetailOrdersRefresh"
            @add-note="onDetailPanelAddNote"
            @schedule="onDetailPanelSchedule"
            @reschedule="onDetailPanelReschedule"
            @refund="onDetailPanelRefund"
          />
        </div>
      </div>
    </Teleport>

    <CareOrderSchedule
      v-if="scheduleOverlayOpen"
      embedded
      :initial-focus="scheduleOverlayFocus"
      :external-refresh-nonce="scheduleExternalRefreshNonce"
      @close="onScheduleOverlayClose"
      @orders-updated="onScheduleOrdersUpdated"
    />

  </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, computed, watch, onMounted, onUnmounted, inject, nextTick } from 'vue'
import type { Ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import {
  postCareOrderDetail,
  careOrderListItemToCardDto,
  orderCardDtoToSidebarRecord,
  parseCareOrderListResponse,
  readCareOrderListPageCount,
  readCareOrderListTotal,
  extractCareOrderListArray,
  postCareOrderLineAction,
  postCareOrderUpdateNotes,
  resolveCareOrderUpdateNotesTarget,
  postCareOrderMeta,
  postCareOrderDelete,
  postCareScheduleContext,
  mergeCareOrderCardPreservingLocalFields,
  type CareOrderMetaData,
  type OrderCardDTO,
  type OrderServiceLineDTO,
  type Technician,
  type OrderListQuery,
  type OrderSearchField,
} from '@/api/orders'
import { fetchCareOrderListCached, invalidateCareOrderListCache } from '@/utils/careOrderListCache'
import type { CareSidebarBadgeRefreshResult } from '@/utils/careSidebarBadgeSync'
import type { OrderRecord } from '@/api/hmCareOrderTypes'
import { fetchActiveTechnicianList } from '@/api/technicianslist'
import {
  applyTechnicianRefsToOrderCard,
  buildTechnicianNoLookup,
  displayTechnicianNo,
  isTechnicianNoTruncated,
  mapCareOrderListToCards,
  mapCareOrderListToCardsRaw,
  patchOrderCardTechnicianRefs,
  truncateTechnicianNoDisplay,
  type TechnicianNoLookup,
} from '@/utils/technicianNoFromList'
import {
  CARE_SERVICE_STATUS_FU_ASSIGNED,
  CARE_SERVICE_STATUS_FU_PENDING_RESCHEDULE,
  CARE_SERVICE_STATUS_FU_PENDING_SCHEDULE,
  CARE_SERVICE_STATUS_ASSIGNED,
  CARE_SERVICE_STATUS_COMPLETED,
  CARE_SERVICE_STATUS_PENDING_RESCHEDULE,
  CARE_SERVICE_STATUS_PENDING_SCHEDULE,
  CARE_SIDEBAR_SUB_BUCKET_API_STATUS,
  careOrderListServiceStatusApiParam,
  careServiceStatusCodeToDisplayLabel,
  classifyCareOrderCardBucket,
  classifyCareSidebarSubBucket,
  type CareSidebarSubBucket,
} from '@/api/hmCareOrderTypes'
import {
  formatOrderScheduleLineDisplay,
  formatSvcTimeDisplay,
  isPendingTimePlaceholderDisplay,
  lineHasConfirmedScheduleTime,
  lineShowsPreferredTimeScheduleGlyph,
  lineShowsPreferredTimeTooltip,
  lineShowsServiceTimeStatusIcon,
  mainLineRowShowsPendingReschedulePreferredBlock,
  followUpRowShowsPreferredRescheduleBlock,
  isFollowUpCareLine,
  normalizeOrderCardForDisplay,
  normalizeOrderCardListForDisplay,
  orderCardIsMainPendingSchedule,
  orderCardIsFuPendingSchedule,
  orderPreferredTimesList,
  orderStatusIsFollowUpContext,
  orderCardHasFollowUpOrder,
  orderHasSchedulableFollowUpLine,
  preserveMainLineOnMergedFollowUpCard,
  resolveOrderCardHeadServiceStatus,
  mainLineInspectionProductCodeDisplay,
} from '@/api/careOrderLineDisplay'
import CalendarMini from './CalendarMini.vue'
import AssignNameTipHost from './AssignNameTipHost.vue'
import PreferredTimeTipHost from './PreferredTimeTipHost.vue'
import CareOrderSchedule, { type CareScheduleFocusPayload } from './CareOrderSchedule.vue'
import NewCareOrder from './NewCareOrder.vue'
import RefundModal from './RefundModal.vue'
import type { RefundSubmitPayload, RefundTaxOption } from './RefundModal.vue'
import {
  buildRefundTaxOptions,
  formatRefundMoney,
  parseRefundTaxRate,
  postCareOrderRefund,
  postCareOrderRefundContext,
  postCareOrderRefundMeta,
  DEFAULT_REFUND_TAX_OPTIONS,
} from '@/api/careOrderRefund'
import ModalButtonSpinner from '@/components/ModalButtonSpinner.vue'
import CareOrderDetailPanel from './CareOrderDetailPanel.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import { HM_CARE_ORDER_DETAIL_KEY, peekHmCareOrdersListPrefill, readHmCareOrdersListPrefill } from '@/api/CareOrderDetailFocus'
import {
  careOrdersDetailRoute,
  careOrdersListRouteForSub,
  careSubKeyForServiceStatusFilter,
  careOrdersNewRoute,
  careOrdersRefundRoute,
  careOrdersRescheduleRoute,
  careOrdersScheduleRoute,
  isCareOrdersDetailRoute,
  isCareOrdersNewRoute,
  isCareOrdersRefundRoute,
  isCareOrdersScheduleOverlayRoute,
  type CareSubKey,
} from '@/utils/careOrdersRoutes'
import { FIELD_LIMITS } from '@/constants/fieldLimits'
import { validateFieldLimits, validateStringLength, fieldLimitError } from '@/utils/fieldLimitValidation'

const orderFieldLimits = FIELD_LIMITS.order
 import imgDown from '@/assets/downarrow@2x.png'
 import imgCal from '@/assets/编组 2@2x.png'
 import imgHmGreen from '@/assets/homemetric_green@2x.png'
import imgSchedule from '@/assets/Schedule,black@2x.png'
import imgPendingSchedule from '@/assets/reschedule@2x.png'
 import imgRefund from '@/assets/refund@2x.png'
 import imgMessage from '@/assets/Message@2x.png'
 import imgNote from '@/assets/note@2x.png'
import imgDelete from '@/assets/delete@2x.png'
import imgListBlank from '@/assets/list_blank@2x.png'
import imgClose from '@/assets/Fill 1@2x.png'
import imgPagerArrow from '@/assets/right arrow@2x.png'
import imgNormal from '@/assets/normal@2x.png'

function serviceTimeStatusIconSrc(order: OrderCardDTO, line: OrderServiceLineDTO): string {
  if (isPendingTimePlaceholderDisplay(line, order)) return imgPendingSchedule
  return imgSchedule
}

function isPendingAssignmentLabel(text: string | undefined): boolean {
  const s = (text ?? '').trim()
  if (!s) return true
  return /^pending\s+assignment$/i.test(s)
}

function showServiceLineIcon(line: OrderServiceLineDTO): boolean {
  return line.serviceName.trim().toLowerCase() !== 'follow-up care'
}

/** 展示 Staff ID：与技术员页 Inspector 下绿色执照号 license_no 一致 */
function formatTechnicianRefDisplay(
  ref: string | number | undefined,
  assignment?: string,
): string {
  return displayTechnicianNo(assignment, ref, technicianNoLookup.value)
}

function technicianRefView(
  ref: string | number | undefined,
  assignment?: string,
): { full: string; display: string; tipText: string } {
  const full = formatTechnicianRefDisplay(ref, assignment)
  return {
    full,
    display: truncateTechnicianNoDisplay(full),
    tipText: isTechnicianNoTruncated(full) ? full : '',
  }
}

function productCodeTagParts(code: string): string[] {
  const raw = (code ?? '').trim()
  if (!raw || raw === '—') return []
  let parts: string[]
  if (/[·•,|]/.test(raw) || raw.includes('/')) {
    parts = raw.split(/\s*(?:[·•]|,|\||\/)\s*/).map((s) => s.trim()).filter(Boolean)
  } else {
    const compact = raw.replace(/\s+/g, ' ')
    if (/^(?:[A-Za-z]{1,3}-\d+\s+)+[A-Za-z]{1,3}-\d+$/i.test(compact)) {
      parts = compact.split(/\s+/).map((s) => s.trim()).filter(Boolean)
    } else {
      parts = [raw]
    }
  }
  return parts.filter((p) => !/^B-\d+$/i.test(p.trim()))
}

function tagToneClass(token: string): string {
  const t = token.trim()
  if (t.startsWith('IC-')) return 'svc-tag-ic'
  if (t.startsWith('I-')) return 'svc-tag-i'
  if (t.startsWith('N-')) return 'svc-tag-n'
  if (t.startsWith('A-')) return 'svc-tag-a'
  if (t.startsWith('U-')) return 'svc-tag-u'
  if (t.startsWith('B-')) return 'svc-tag-b'
  if (t.startsWith('P-')) return 'svc-tag-p'
  if (t.startsWith('F-')) return 'svc-tag-f'
  return 'svc-tag-plain'
}

/** Pending Schedule 主单：不展示 svc-tags（含 P-x / svc-tag-p） */
function shouldShowMainLineInspectionTags(order: OrderCardDTO): boolean {
  if (orderCardIsMainPendingSchedule(order)) return false
  return resolveOrderCardHeadServiceStatus(order) !== CARE_SERVICE_STATUS_PENDING_SCHEDULE
}

/** 数据里常已带 “Notes:”，横幅又写 “Notes:”，去掉重复前缀 */
function displayNotesBannerBody(notes: string): string {
  let s = notes.trim()
  while (/^notes\s*:/i.test(s)) {
    s = s.replace(/^notes\s*:\s*/i, '').trim()
  }
  return s
}

const careOrdersRef = inject<Ref<OrderRecord[]>>('careOrders')
const refreshCareSidebarBadges = inject<
  (() => Promise<CareSidebarBadgeRefreshResult | null>) | undefined
>('refreshCareSidebarBadges', undefined)

/** 通过 care-order/sidebar-stats 回拉侧栏气泡 */
function refreshSidebarBadgesNow(): void {
  if (!refreshCareSidebarBadges) return
  void refreshCareSidebarBadges()
}

type CareOrdersSubKey =
  | 'hm_orders'
  | 'pend_sched'
  | 'pend_resched'
  | 'fu_pend_sched'
  | 'fu_pend_resched'
  | 'hm_care_subscription'

function isCareOrdersFourSubKey(key: CareOrdersSubKey): key is CareSidebarSubBucket {
  return (
    key === 'pend_sched' ||
    key === 'pend_resched' ||
    key === 'fu_pend_sched' ||
    key === 'fu_pend_resched'
  )
}

/** 四子页 list 请求的 service_status（服务端分页，不再客户端 slice） */
function listServiceStatusForCareSubKey(key: CareOrdersSubKey): string | undefined {
  if (!isCareOrdersFourSubKey(key)) return undefined
  return careOrderListServiceStatusApiParam(CARE_SIDEBAR_SUB_BUCKET_API_STATUS[key])
}

/** HM Care Orders + 四个状态子目录：列表走服务端分页 */
function usesHmCareOrdersFullSet(): boolean {
  return props.careSubKey === 'hm_orders' || isCareOrdersFourSubKey(props.careSubKey)
}

/** 排程焦点订单来源：仅当前页列表（不再依赖多 status 全集缓存） */
function hmCareOrdersFullSetSnapshot(): OrderCardDTO[] {
  return orders.value
}

/** 侧栏四子项：从「Home Care 全量」订单里筛出归入该桶的订单 */
function filterOrdersForCareSubKey(full: OrderCardDTO[], key: CareSidebarSubBucket): OrderCardDTO[] {
  return full.filter((o) => classifyCareOrderCardBucket(o) === key)
}

/** 从主单 Pending Schedule 进入：仅主单待排；从 FU Pending Schedule 进入：仅 FU 待排 */
function orderIsFollowUpScheduleContext(order: OrderCardDTO, lineIndex: number): boolean {
  if (orderStatusIsFollowUpContext(order.status)) return true
  if (classifyCareOrderCardBucket(order) === 'fu_pend_sched') return true
  const line = order.services[lineIndex]
  return !!(line && isFollowUpCareLine(line))
}

/** Schedule Follow-up 左栏：与 FU-Pending Schedule 子目录列表同一套归类 */
function orderBelongsToScheduleFuPool(order: OrderCardDTO): boolean {
  if (!orderIsFuPendingScheduleOrder(order)) return false
  if (classifyCareOrderCardBucket(order) === 'fu_pend_sched') return true
  return order.services.some((l) => isFollowUpCareLine(l) && l.canSchedule !== false)
}

function filterOrdersEligibleForSchedule(
  full: OrderCardDTO[],
  focusOrder: OrderCardDTO,
  focusLineIndex: number,
): OrderCardDTO[] {
  const fuSession =
    props.careSubKey === 'fu_pend_sched' ||
    orderIsFollowUpScheduleContext(focusOrder, focusLineIndex)
  const filtered = full.filter((o) => {
    if (orderStatusIsCompleted(o.status)) return false
    if (fuSession) {
      return orderBelongsToScheduleFuPool(o)
    }
    const bucket = classifyCareOrderCardBucket(o)
    if (bucket !== 'pend_sched' && !orderCardIsMainPendingSchedule(o)) return false
    if (orderStatusIsFollowUpContext(o.status)) return false
    return o.services.some((l) => !isFollowUpCareLine(l) && (l.canSchedule || orderCardIsMainPendingSchedule(o)))
  })
  if (!filtered.some((o) => o.id === focusOrder.id)) {
    if (
      focusOrder &&
      !orderStatusIsCompleted(focusOrder.status) &&
      (fuSession
        ? orderBelongsToScheduleFuPool(focusOrder)
        : focusOrder.services.some((l) => !isFollowUpCareLine(l) && l.canSchedule))
    ) {
      return [focusOrder, ...filtered]
    }
  }
  return filtered.length ? filtered : full.filter((o) => o.id === focusOrder.id)
}

/** 改期弹窗：是否 FU 状态会话（Reschedule Follow-up 池） */
function orderIsRescheduleFollowUpContext(order: OrderCardDTO, lineIndex: number): boolean {
  const line = order.services[lineIndex]
  if (line && isFollowUpCareLine(line)) return true
  if (orderStatusIsFollowUpContext(order.status)) return true
  return classifyCareOrderCardBucket(order) === 'fu_pend_resched'
}

/** Reschedule Follow-up 左栏：仅 FU 状态且跟进行可改期 */
function followUpLineEligibleForReschedulePool(
  line: OrderServiceLineDTO,
  order: OrderCardDTO,
): boolean {
  if (!isFollowUpCareLine(line)) return false
  if (line.canReschedule) return true
  return lineHasConfirmedScheduleTime(line, order)
}

/** Reschedule 主单左栏：主单 Pending Reschedule 或已排期可改期 */
function mainLineEligibleForReschedulePool(
  line: OrderServiceLineDTO,
  order: OrderCardDTO,
): boolean {
  if (isFollowUpCareLine(line)) return false
  if (orderIsMainPendingRescheduleOrder(order)) return true
  if (line.canReschedule) return true
  return lineHasConfirmedScheduleTime(line, order)
}

function orderHasRescheduleEligibleLine(order: OrderCardDTO, fuSession: boolean): boolean {
  if (!fuSession && orderIsMainPendingRescheduleOrder(order)) return true
  return order.services.some((l) => l.canReschedule || lineHasConfirmedScheduleTime(l, order))
}

function orderBelongsToRescheduleFuPool(order: OrderCardDTO): boolean {
  const bucket = classifyCareOrderCardBucket(order)
  const code = (order.serviceStatusCode ?? '').trim().toLowerCase()
  const isFuStatus =
    orderStatusIsFollowUpContext(order.status) ||
    bucket === 'fu_pend_resched' ||
    code === 'fu_pending_reschedule' ||
    code === 'fu_assigned' ||
    code === 'follow_up_assigned'
  if (!isFuStatus || bucket === 'fu_pend_sched') return false
  return order.services.some((l) => followUpLineEligibleForReschedulePool(l, order))
}

function orderBelongsToRescheduleMainPool(order: OrderCardDTO): boolean {
  if (orderStatusIsFollowUpContext(order.status)) return false
  const bucket = classifyCareOrderCardBucket(order)
  if (bucket === 'fu_pend_resched') return false
  return order.services.some((l) => mainLineEligibleForReschedulePool(l, order))
}

function filterOrdersForRescheduleOverlay(
  full: OrderCardDTO[],
  focusOrderId: string,
  focusLineIndex: number,
): OrderCardDTO[] {
  const focusOrder = full.find((o) => o.id === focusOrderId)
  const fuSession =
    props.careSubKey === 'fu_pend_resched' ||
    (focusOrder ? orderIsRescheduleFollowUpContext(focusOrder, focusLineIndex) : false)

  const eligible = full.filter((o) => {
    if (orderStatusIsCompleted(o.status)) return false
    if (!orderHasRescheduleEligibleLine(o, fuSession)) return false
    return fuSession ? orderBelongsToRescheduleFuPool(o) : orderBelongsToRescheduleMainPool(o)
  })
  if (!eligible.some((o) => o.id === focusOrderId)) {
    const focus = full.find((o) => o.id === focusOrderId)
    const focusCanReschedule =
      focus?.services.some((l) => l.canReschedule) || (!!focus && orderIsMainPendingRescheduleOrder(focus))
    if (
      focus &&
      !orderStatusIsCompleted(focus.status) &&
      focusCanReschedule &&
      (fuSession ? orderBelongsToRescheduleFuPool(focus) : orderBelongsToRescheduleMainPool(focus))
    ) {
      return [focus, ...eligible]
    }
  }
  return eligible.length ? eligible : full.filter((o) => o.id === focusOrderId)
}

function buildScheduleFocusPayload(
  order: OrderCardDTO,
  line: OrderServiceLineDTO,
  lineIndex: number,
  mode: 'schedule' | 'reschedule',
): CareScheduleFocusPayload {
  const full = hmCareOrdersFullSetSnapshot()
  const overlaySource = full.length > 0 ? full : orders.value
  const focusOrder = overlaySource.find((o) => o.id === order.id) ?? order
  const orderList = [focusOrder]
  return {
    orderId: order.id,
    lineIndex,
    serviceName: line.serviceName,
    address: line.address,
    homeId: order.homeId,
    serviceCycleDate: serviceCycleYmdForScheduleFocus(order, lineIndex),
    orderList,
    mode,
    followUpPrimaryId:
      isFollowUpCareLine(line) && line.followUpPrimaryId != null && line.followUpPrimaryId > 0
        ? Math.trunc(line.followUpPrimaryId)
        : undefined,
    rescheduleKind:
      mode === 'reschedule'
        ? orderIsCustomerRequestedRescheduleOrder(order, line)
          ? 'customer'
          : 'proactive'
        : undefined,
  }
}

function prepareScheduleOpen(payload: CareScheduleFocusPayload) {
  showScheduleOverlay(payload)
}

function showScheduleOverlay(payload: CareScheduleFocusPayload) {
  scheduleOverlayFocus.value = payload
  scheduleOverlayOpen.value = true
}

/** 今日 YYYY-MM-DD，供 reschedule 预检 context 的 week_start */
function todayYmdForScheduleContext(): string {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

/**
 * Reschedule 打开弹框前先打 care-schedule/context：
 * code=200 才允许打开；业务失败（如 On the Way / In Progress）用 toast 提示 msg。
 */
async function ensureRescheduleContextAllowed(
  order: OrderCardDTO,
  lineIndex: number,
): Promise<boolean> {
  const target = await resolveCareOrderUpdateNotesTarget(order, lineIndex, postCareOrderDetail)
  if (!target) {
    emit('toast', { type: 'error', message: 'Cannot reschedule: order id is missing.' })
    return false
  }
  try {
    await postCareScheduleContext({
      target_type: target.target_type,
      target_id: target.target_id,
      week_start: todayYmdForScheduleContext(),
    })
    return true
  } catch (e: unknown) {
    emit('toast', { type: 'warning', message: apiErrorMessage(e) })
    return false
  }
}

async function openScheduleOverlay(
  order: OrderCardDTO,
  line: OrderServiceLineDTO,
  lineIndex: number,
  mode: 'schedule' | 'reschedule',
) {
  if (mode === 'reschedule') {
    const busyKey = lineActionBusyKey(order.id, lineIndex)
    if (lineActionBusy.value === busyKey) return
    lineActionBusy.value = busyKey
    try {
      const allowed = await ensureRescheduleContextAllowed(order, lineIndex)
      if (!allowed) return
    } finally {
      if (lineActionBusy.value === busyKey) lineActionBusy.value = null
    }
  }

  const payload = buildScheduleFocusPayload(order, line, lineIndex, mode)
  // 焦点只走内存 props，不再写 careScheduleFocus session（不需要刷新恢复）
  prepareScheduleOpen(payload)
  void router.push(
    mode === 'schedule'
      ? careOrdersScheduleRoute(order.id, lineIndex)
      : careOrdersRescheduleRoute(order.id, lineIndex),
  )
}

function isOrderEligibleForSchedule(order: OrderCardDTO): boolean {
  const bucket = classifyCareOrderCardBucket(order)
  if (bucket === 'pend_sched' || bucket === 'fu_pend_sched') return true
  const head = resolveOrderCardHeadServiceStatus(order)
  if (
    head === CARE_SERVICE_STATUS_FU_PENDING_SCHEDULE ||
    head === CARE_SERVICE_STATUS_PENDING_SCHEDULE
  ) {
    return true
  }
  if (orderHasSchedulableFollowUpLine(order)) {
    const main = order.services.find((l) => !isFollowUpCareLine(l))
    return !!main && lineHasConfirmedScheduleTime(main, order)
  }
  return false
}

/** 主单 Pending Reschedule（非 FU）：无 Add notes */
function orderIsMainPendingRescheduleStatus(status: string | undefined): boolean {
  const bucket = classifyCareSidebarSubBucket(status ?? '')
  if (bucket === 'pend_resched') return true
  const n = (status ?? '').trim().toLowerCase()
  return n.includes('pending') && n.includes('reschedule') && !n.includes('follow') && !/\bfu\b/.test(n)
}

function orderIsFuPendingRescheduleStatus(status: string | undefined): boolean {
  const bucket = classifyCareSidebarSubBucket(status ?? '')
  if (bucket === 'fu_pend_resched') return true
  const n = (status ?? '').trim().toLowerCase()
  return (n.includes('follow') || /\bfu\b/.test(n)) && n.includes('pending') && n.includes('reschedule')
}

/** FU-Pending Reschedule 订单（页头文案或跟进行桶归类） */
function orderIsFuPendingRescheduleOrder(order: OrderCardDTO): boolean {
  if (orderIsFuPendingRescheduleStatus(order.status)) return true
  return classifyCareOrderCardBucket(order) === 'fu_pend_resched'
}

/** 主单 Pending Reschedule 订单（页头文案或主单桶归类；含 pend_resched 子目录） */
function orderIsMainPendingRescheduleOrder(order: OrderCardDTO): boolean {
  if (orderIsFuPendingRescheduleOrder(order)) return false
  if (orderIsMainPendingRescheduleStatus(order.status)) return true
  if (classifyCareOrderCardBucket(order) === 'pend_resched') return true
  if (props.careSubKey === 'pend_resched') return true
  return false
}

/** FU-Pending Schedule 订单（页头文案或跟进行桶归类） */
function orderIsFuPendingScheduleOrder(order: OrderCardDTO): boolean {
  const bucket = classifyCareOrderCardBucket(order)
  if (bucket === 'fu_pend_sched') return true
  const head = resolveOrderCardHeadServiceStatus(order)
  return head === CARE_SERVICE_STATUS_FU_PENDING_SCHEDULE
}

/** Schedule / Reschedule 按钮所作用的服务行（合并卡跟进行上下文指向跟进行） */
function scheduleActionTargetForOrder(
  order: OrderCardDTO,
  line?: OrderServiceLineDTO,
  lineIndex?: number,
): { line: OrderServiceLineDTO; lineIndex: number } {
  if (orderUsesMergedAssignPayLayout(order)) {
    return mergedScheduleActionTarget(order)
  }
  if (line != null && lineIndex != null) {
    return { line, lineIndex }
  }
  const main = order.services.find((l) => !isFollowUpCareLine(l)) ?? order.services[0]!
  const idx = order.services.indexOf(main)
  return { line: main, lineIndex: idx >= 0 ? idx : 0 }
}

function lineAllowsNoteAction(
  order: OrderCardDTO,
  line: OrderServiceLineDTO,
  _lineIndex: number,
): boolean {
  if (orderIsFuPendingRescheduleOrder(order)) return true
  return line.canNote !== false
}

/** 客户发起改期（含 FU / 主单 Pending Reschedule）：排期 overlay 走 customer 模式 */
function orderIsCustomerRequestedRescheduleStatus(status: string | undefined): boolean {
  return orderIsMainPendingRescheduleStatus(status) || orderIsFuPendingRescheduleStatus(status)
}

function orderIsCustomerRequestedRescheduleOrder(
  order: OrderCardDTO,
  line: OrderServiceLineDTO,
): boolean {
  if (orderIsCustomerRequestedRescheduleStatus(order.status)) {
    if (orderIsMainPendingRescheduleOrder(order) || orderIsFuPendingRescheduleOrder(order)) {
      return true
    }
    return lineHasConfirmedScheduleTime(line, order)
  }
  return orderIsMainPendingRescheduleOrder(order)
}

/** 主单 Pending Reschedule：行尾仅 Reschedule、Refund、Send Messages（无 Add notes） */
function orderUsesRescheduleActionMenu(order: OrderCardDTO): boolean {
  return orderIsMainPendingRescheduleOrder(order)
}

function orderShowsAddNotesAction(order: OrderCardDTO): boolean {
  if (orderIsFuPendingRescheduleOrder(order)) return true
  return !orderIsMainPendingRescheduleOrder(order)
}

function orderShowsNotesBanner(order: OrderCardDTO): boolean {
  if (orderIsMainPendingRescheduleOrder(order)) return false
  return !!(order.notes?.trim())
}

function orderStatusIsAssigned(serviceStatusLabel: string | undefined): boolean {
  const raw = (serviceStatusLabel ?? '').trim()
  if (!raw || raw === '—') return false
  const s = raw.toLowerCase()
  if (s.includes('unassigned') || s.includes('pending') || s.includes('reschedule')) return false
  const k = s.replace(/[\s-]+/g, '_')
  if (k === 'assigned' || k === 'fu_assigned' || k === 'follow_up_assigned') return true
  if (/\bfu[\s_-]*assigned\b/.test(s) || /\bfollow[\s-]*up[\s_-]*assigned\b/.test(s)) return true
  return /\bassigned\b/.test(s)
}

function orderStatusIsCompleted(serviceStatusLabel: string | undefined): boolean {
  const raw = (serviceStatusLabel ?? '').trim()
  if (!raw || raw === '—') return false
  const s = raw.toLowerCase()
  if (s.includes('incomplete')) return false
  if (s.includes('pending')) return false
  if (/\bcompleted\b/.test(s) || /\bcompeted\b/.test(s)) return true
  if (/\bfu[\s_-]*completed\b/.test(s) || /\bfollow[\s-]*up[\s_-]*completed\b/.test(s)) return true
  return /\bcomplete\b/.test(s)
}

function lineRescheduleDisabled(order: OrderCardDTO, line: OrderServiceLineDTO, lineIndex: number): boolean {
  if (isLineActionBusy(order.id, lineIndex)) return true
  if (orderStatusIsCompleted(order.status)) return true
  if (orderIsMainPendingRescheduleOrder(order)) return false
  if (lineHasConfirmedScheduleTime(line, order)) return false
  return line.canReschedule === false
}

/** Assigned / Completed / 已排期 / Pending Reschedule：Reschedule；Pending Schedule（含 FU）仍为 Schedule */
function orderUsesRescheduleWithNotesActionMenu(
  order: OrderCardDTO,
  line?: OrderServiceLineDTO,
  lineIndex?: number,
): boolean {
  if (orderIsMainPendingRescheduleStatus(order.status)) return false
  if (orderIsMainPendingRescheduleOrder(order)) return false
  const { line: targetLine } = scheduleActionTargetForOrder(order, line, lineIndex)
  if (orderIsFuPendingRescheduleOrder(order) && isFollowUpCareLine(targetLine)) return true

  if (!isFollowUpCareLine(targetLine) && orderCardIsMainPendingSchedule(order)) return false
  if (isFollowUpCareLine(targetLine) && orderIsFuPendingScheduleOrder(order)) return false

  if (lineHasConfirmedScheduleTime(targetLine, order)) return true

  const status = order.status
  return orderStatusIsAssigned(status) || orderStatusIsCompleted(status)
}

/** 新建订单 service sycle / 列表 service_date / 行内 YYYY-MM-DD */
function serviceCycleYmdForScheduleFocus(order: OrderCardDTO, lineIndex: number): string {
  const fromOrder = order.serviceDate?.trim()
  if (fromOrder) {
    const m = fromOrder.match(/(\d{4}-\d{2}-\d{2})/)
    if (m) return m[1]!
  }
  const line = order.services[lineIndex] ?? order.services[0]
  const raw = (line?.scheduledAt ?? '').trim()
  const m = raw.match(/(\d{4}-\d{2}-\d{2})/)
  if (m) return m[1]!
  return ''
}

const props = withDefaults(
  defineProps<{
    careSubKey?: CareOrdersSubKey
  }>(),
  { careSubKey: 'hm_orders' },
)

const emit = defineEmits<{
  toast: [{ type: 'success' | 'warning' | 'error'; message: string }]
}>()

const router = useRouter()
const route = useRoute()

const HM_CARE_ORDER_LOCAL_INSERT_KEY = 'hmCareOrderLocalInsert'

const scheduleOverlayOpen = ref(false)
const scheduleOverlayFocus = ref<CareScheduleFocusPayload | null>(null)
const scheduleExternalRefreshNonce = ref(0)
const newOrderModalOpen = ref(false)
const orderDetailOverlayOrder = ref<OrderCardDTO | null>(null)
const orderDetailNeedsListRefresh = ref(false)
const orderDeleteModalOpen = ref(false)
const orderDeleteTarget = ref<OrderCardDTO | null>(null)
const orderDeleteSubmitting = ref(false)

function onScheduleOrdersUpdated(patches: OrderCardDTO[]) {
  if (!patches.length) return
  const lookup = technicianNoLookup.value
  const list = lookup ? patches.map((o) => applyTechnicianRefsToOrderCard(o, lookup)) : patches
  mergeScheduleOrdersIntoCurrentList(list)
  if (orderDetailOverlayOrder.value) {
    const detailPatch = list.find((p) =>
      careOrderCardsReferToSameOrder(p, orderDetailOverlayOrder.value!),
    )
    if (detailPatch) {
      orderDetailOverlayOrder.value = mergeScheduleOrderPatch(
        orderDetailOverlayOrder.value,
        detailPatch,
      )
    }
  }
  syncSidebarFromList(orders.value)
}

/**
 * 关闭排程弹层后的刷新策略：
 * 1. 本地合并 patches — 立即更新表格
 * 2. loadOrders — 当前子页服务端分页（1 次）
 * 3. refreshSidebarBadgesNow — POST care-order/sidebar-stats 更新侧栏气泡
 */
function onScheduleOverlayClose(patchesFromClose?: OrderCardDTO[]) {
  const patches = patchesFromClose?.length ? patchesFromClose : []
  scheduleOverlayOpen.value = false
  scheduleOverlayFocus.value = null
  clearScheduleSessionStorage()

  if (isCareOrdersScheduleOverlayRoute(route)) {
    if (orderDetailOverlayOrder.value) {
      void router.replace(careOrdersDetailRoute(orderDetailOverlayOrder.value.id))
    } else {
      void router.replace(careListRouteForPropsSub())
    }
  }

  if (patches.length) {
    onScheduleOrdersUpdated(patches)
  }

  void loadOrders().then(() => {
    if (patches.length) {
      onScheduleOrdersUpdated(patches)
    }
    refreshSidebarBadgesNow()
  })
}

/** 排程弹层关闭后不再用 session 快照覆盖列表，仅清理遗留键 */
function clearScheduleSessionStorage() {
  try {
    sessionStorage.removeItem('hmCareOrderScheduleOrderList')
    sessionStorage.removeItem('hmCareOrderSchedulePatches')
  } catch {
    /* ignore */
  }
}

const isFuPendingRescheduleView = computed(() => props.careSubKey === 'fu_pend_resched')
const isFuPendingScheduleView = computed(() => props.careSubKey === 'fu_pend_sched')
const isPendScheduleView = computed(() => props.careSubKey === 'pend_sched')
const isPendRescheduleView = computed(() => props.careSubKey === 'pend_resched')
const isPendSubFilterView = computed(() => isPendScheduleView.value || isPendRescheduleView.value)
const isFuSpecialFilterView = computed(
  () => isFuPendingRescheduleView.value || isFuPendingScheduleView.value,
)

/** 订单卡片页头 Service Status（有 Follow-up 行时必须为 Follow-up-* 八种状态之一） */
function orderCardHeadServiceStatusDisplay(order: OrderCardDTO): string {
  const resolved = resolveOrderCardHeadServiceStatus(order)
  const k = props.careSubKey
  if (orderCardHasFollowUpOrder(order)) return resolved
  if (k === 'pend_sched') return 'Pending Schedule'
  if (k === 'pend_resched') return 'Pending Reschedule'
  if (k === 'fu_pend_sched') return CARE_SERVICE_STATUS_FU_PENDING_SCHEDULE
  if (k === 'fu_pend_resched') return CARE_SERVICE_STATUS_FU_PENDING_RESCHEDULE
  return resolved || '—'
}

function orderPreferredTimeTipEntries(order: OrderCardDTO): string[] {
  return orderPreferredTimesList(order).map((pt) => formatOrderScheduleLineDisplay(pt))
}

function linePreferredTimeTipEntries(order: OrderCardDTO, line: OrderServiceLineDTO): string[] {
  return scheduleGlyphTooltipEntries(order, line).map((pt) => formatOrderScheduleLineDisplay(pt))
}

/** 主行 + Follow-up 两行时：服务人员分两格，支付/详情/操作合并为一格（与稿一致） */
function orderUsesMergedAssignPayLayout(order: OrderCardDTO): boolean {
  const main = order.services.find((l) => !isFollowUpCareLine(l))
  const fu = resolveMergedFollowUpLine(order)
  return main != null && fu != null
}

function resolveMergedFollowUpLineIndex(order: OrderCardDTO): number {
  const lines = order.services
  let bestIdx = -1
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i]!
    if (!isFollowUpCareLine(line)) continue
    if (bestIdx < 0) {
      bestIdx = i
      continue
    }
    const cur = lines[bestIdx]!
    const curPlaceholder =
      isPendingAssignmentLabel(cur.assignment) && !cur.technicianRef?.trim()
    const candPlaceholder =
      isPendingAssignmentLabel(line.assignment) && !line.technicianRef?.trim()
    if (curPlaceholder && !candPlaceholder) {
      bestIdx = i
      continue
    }
    if (!curPlaceholder && candPlaceholder) continue
    if ((line.followUpPrimaryId ?? 0) > (cur.followUpPrimaryId ?? 0)) bestIdx = i
  }
  return bestIdx
}

function resolveMergedFollowUpLine(order: OrderCardDTO): OrderServiceLineDTO | null {
  const idx = resolveMergedFollowUpLineIndex(order)
  return idx >= 0 ? (order.services[idx] ?? null) : null
}

/** 合并卡片跟进行指派格是否仍显示 Pending Assignment（以跟进行排程结果为准，不受子页页头占位文案影响） */
function mergedFollowUpAssignShowsPending(order: OrderCardDTO): boolean {
  if (!orderUsesMergedAssignPayLayout(order)) {
    return orderCardHeadServiceStatusDisplay(order).includes('Pending')
  }
  const fu = mergedFollowUpLine(order)
  const assign = (fu.assignment ?? '').trim()
  if (assign && !isPendingAssignmentLabel(assign)) return false
  if (fu.technicianRef) return false
  if (lineHasConfirmedScheduleTime(fu, order)) return false
  return isPendingAssignmentLabel(fu.assignment)
}

const MERGED_SVC_INDEXES = [0, 1] as const

function mergedCareLine(order: OrderCardDTO, idx: 0 | 1): OrderServiceLineDTO {
  const lines = order.services
  return lines[idx]!
}

function mergedMainLine(order: OrderCardDTO): OrderServiceLineDTO {
  return mergedCareLine(order, 0)
}

function mergedFollowUpLine(order: OrderCardDTO): OrderServiceLineDTO {
  return resolveMergedFollowUpLine(order) ?? mergedCareLine(order, 1)
}

/** 合并卡片：Follow-up 状态订单的 Schedule / Reschedule 只改跟进行时段 */
function mergedScheduleActionTarget(order: OrderCardDTO): { line: OrderServiceLineDTO; lineIndex: number } {
  const fuIdxWithPk = order.services.findIndex(
    (l) =>
      isFollowUpCareLine(l) && l.followUpPrimaryId != null && l.followUpPrimaryId > 0,
  )
  const fuIdx =
    fuIdxWithPk >= 0
      ? fuIdxWithPk
      : order.services.findIndex((l) => isFollowUpCareLine(l))
  if (fuIdx < 0) return { line: mergedMainLine(order), lineIndex: 0 }
  const fu = order.services[fuIdx]!
  const head = resolveOrderCardHeadServiceStatus(order)
  if (
    head === CARE_SERVICE_STATUS_FU_PENDING_SCHEDULE ||
    head === CARE_SERVICE_STATUS_FU_PENDING_RESCHEDULE ||
    head === CARE_SERVICE_STATUS_FU_ASSIGNED
  ) {
    return { line: fu, lineIndex: fuIdx }
  }
  const code = (order.serviceStatusCode ?? '').trim().toLowerCase()
  if (code === 'fu_assigned' || code === 'follow_up_assigned') {
    return { line: fu, lineIndex: fuIdx }
  }
  if (orderStatusIsFollowUpContext(order.status)) return { line: fu, lineIndex: fuIdx }
  const bucket = classifyCareOrderCardBucket(order)
  if (bucket === 'fu_pend_sched' || bucket === 'fu_pend_resched') {
    return { line: fu, lineIndex: fuIdx }
  }
  // 合并卡主单已排程、跟进行可改期：Reschedule 只动 Follow-up 行
  if (fu.canReschedule) return { line: fu, lineIndex: fuIdx }
  if (fu.canSchedule) return { line: fu, lineIndex: fuIdx }
  return { line: mergedMainLine(order), lineIndex: 0 }
}

function mergedScheduleActionDisabled(order: OrderCardDTO): boolean {
  const target = mergedScheduleActionTarget(order)
  const head = resolveOrderCardHeadServiceStatus(order)
  if (isFollowUpCareLine(target.line) && head === CARE_SERVICE_STATUS_FU_PENDING_SCHEDULE) {
    return isLineActionBusy(order.id, target.lineIndex)
  }
  return target.line.canSchedule === false || isLineActionBusy(order.id, target.lineIndex)
}

function lineScheduleActionDisabled(
  order: OrderCardDTO,
  line: OrderServiceLineDTO,
  lineIndex: number,
): boolean {
  const head = resolveOrderCardHeadServiceStatus(order)
  if (!isFollowUpCareLine(line) && head === CARE_SERVICE_STATUS_PENDING_SCHEDULE) {
    return isLineActionBusy(order.id, lineIndex)
  }
  return line.canSchedule === false || isLineActionBusy(order.id, lineIndex)
}

/** 主行 / Follow-up 行待排期图标旁黄底：仅用订单 preferredTimes 或行内已排期文案（无本地伪造时段） */
function scheduleGlyphTooltipEntries(order: OrderCardDTO, line: OrderServiceLineDTO): string[] {
  if (lineHasConfirmedScheduleTime(line, order)) return []
  const pref = orderPreferredTimesList(order)
  if (pref.length) return pref
  let slot = (line.scheduledAt ?? '').trim()
  if (isFollowUpCareLine(line)) {
    slot = slot.replace(/^(follow-up-|fu-)/i, '').trim()
  }
  if (
    slot &&
    slot !== '—' &&
    !/^pending\s*schedule$/i.test(slot) &&
    !/^pending\s*reschedule$/i.test(slot)
  ) {
    return [(line.scheduledAt ?? '').trim()]
  }
  return []
}

function mergedFollowUpAssignBottomAriaLabel(order: OrderCardDTO): string {
  if (mergedFollowUpAssignShowsPending(order)) return 'Follow-up pending assignment'
  const fu = mergedFollowUpLine(order)
  const name = (fu.assignment ?? '').trim()
  if (name && !isPendingAssignmentLabel(name)) return `Technician ${name}`
  return 'Pending assignment'
}

const rootRef = ref<HTMLElement | null>(null)
const ordersBodyRef = ref<HTMLElement | null>(null)
const openDd = ref<'field' | 'status' | 'tech' | 'insp' | null>(null)
const openCal = ref<'service' | 'followup' | null>(null)

const ORDER_SEARCH_FIELDS_SET = new Set<string>([
  'order_id',
  'home_id',
  'contact_phone_number',
  'address',
  'report_id',
  'follow_up_id',
  'subscription_id',
  'user_id',
])

function isOrderSearchField(v: string): v is OrderSearchField {
  return ORDER_SEARCH_FIELDS_SET.has(v)
}

const FALLBACK_SEARCH_KEYS: OrderSearchField[] = [
  'order_id',
  'home_id',
  'contact_phone_number',
  'address',
  'report_id',
  'follow_up_id',
  'subscription_id',
]

const FALLBACK_SEARCH_LABELS: Record<OrderSearchField, string> = {
  order_id: 'Order ID',
  home_id: 'Home ID',
  user_id: 'User ID',
  contact_phone_number: 'Contact Phone Number',
  address: 'Address',
  subscription_id: 'Subscription ID',
  report_id: 'Report ID',
  follow_up_id: 'Follow-up ID',
  service_address: 'Service Address',
  contact_name: 'Contact Name',
}

const FALLBACK_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'pending_schedule', label: 'Pending Schedule' },
  { value: 'pending_reschedule', label: 'Pending Reschedule' },
  { value: 'assigned', label: 'Assigned' },
  { value: 'completed', label: 'Completed' },
  { value: 'fu_pending_schedule', label: 'FU-Pending Schedule' },
  { value: 'fu_pending_reschedule', label: 'FU-Pending Reschedule' },
  { value: 'fu_assigned', label: 'FU-Assigned' },
  { value: 'fu_completed', label: 'FU-Completed' },
]

/** 与订单卡片页头 Service Status（resolveOrderCardHeadServiceStatus）八种文案一致 */
const CARD_ALIGNED_SERVICE_STATUS_OPTIONS: { value: string; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'pending_schedule', label: CARE_SERVICE_STATUS_PENDING_SCHEDULE },
  { value: 'pending_reschedule', label: CARE_SERVICE_STATUS_PENDING_RESCHEDULE },
  { value: 'assigned', label: CARE_SERVICE_STATUS_ASSIGNED },
  { value: 'completed', label: CARE_SERVICE_STATUS_COMPLETED },
  { value: 'fu_pending_schedule', label: 'FU-Pending Schedule' },
  { value: 'fu_pending_reschedule', label: 'FU-Pending Reschedule' },
  { value: 'fu_assigned', label: 'FU-Assigned' },
  { value: 'fu_completed', label: 'FU-Completed' },
]

const careMeta = ref<CareOrderMetaData | null>(null)

const PREFERRED_SEARCH_KEY_ORDER: OrderSearchField[] = [
  'order_id',
  'home_id',
  'user_id',
  'contact_phone_number',
  'address',
  'subscription_id',
  'report_id',
  'follow_up_id',
]

function mergeSearchFieldKeys(metaKeys: OrderSearchField[]): OrderSearchField[] {
  const set = new Set<OrderSearchField>(metaKeys)
  set.add('home_id')
  set.add('user_id')
  return PREFERRED_SEARCH_KEY_ORDER.filter((k) => set.has(k))
}

const searchFieldKeys = computed<OrderSearchField[]>(() => {
  const st = careMeta.value?.search_types
  if (st?.length) {
    const keys: OrderSearchField[] = []
    for (const x of st) {
      const v = String(x.value)
      if (isOrderSearchField(v)) keys.push(v)
    }
    return keys.length ? mergeSearchFieldKeys(keys) : mergeSearchFieldKeys(FALLBACK_SEARCH_KEYS)
  }
  return mergeSearchFieldKeys(FALLBACK_SEARCH_KEYS)
})

const searchFieldLabels = computed(() => {
  const m: Record<string, string> = { ...FALLBACK_SEARCH_LABELS }
  if (careMeta.value?.search_types) {
    for (const x of careMeta.value.search_types) {
      const v = String(x.value)
      if (isOrderSearchField(v)) m[v] = x.label
    }
  }
  m.home_id = 'Home ID'
  m.user_id = 'User ID'
  return m as Record<OrderSearchField, string>
})

function searchQueryLimitForField(field: OrderSearchField): number {
  switch (field) {
    case 'order_id':
      return orderFieldLimits.orderId
    case 'home_id':
      return orderFieldLimits.homeId
    case 'contact_phone_number':
      return orderFieldLimits.contactPhone
    case 'service_address':
      return orderFieldLimits.serviceAddress
    case 'contact_name':
      return orderFieldLimits.contactName
    default:
      return orderFieldLimits.serviceAddress
  }
}

function validateSearchQueryLength(): string | null {
  const q = form.searchQuery.trim()
  if (!q) return null
  const label = searchFieldLabels.value[form.searchField] ?? 'Search'
  return validateStringLength(q, searchQueryLimitForField(form.searchField), label)
}

let lastSearchLimitToastAt = 0

function showSearchLimitToast(field: OrderSearchField = form.searchField): void {
  const now = Date.now()
  if (now - lastSearchLimitToastAt < 1200) return
  lastSearchLimitToastAt = now
  const label = searchFieldLabels.value[field] ?? 'Search'
  emit('toast', {
    type: 'warning',
    message: fieldLimitError(label, searchQueryLimitForField(field)),
  })
}

function onSearchQueryInput(e: Event): void {
  const el = e.target as HTMLInputElement
  const limit = searchQueryLimitForField(form.searchField)
  let next = el.value
  if (next.length > limit) {
    next = next.slice(0, limit)
    el.value = next
    showSearchLimitToast()
  }
  form.searchQuery = next
}

function onSearchQueryPaste(e: ClipboardEvent): void {
  const paste = e.clipboardData?.getData('text') ?? ''
  if (!paste) return
  const limit = searchQueryLimitForField(form.searchField)
  const el = e.target as HTMLInputElement
  const start = el.selectionStart ?? form.searchQuery.length
  const end = el.selectionEnd ?? start
  const merged = form.searchQuery.slice(0, start) + paste + form.searchQuery.slice(end)
  if (merged.length <= limit) return
  e.preventDefault()
  const next = merged.slice(0, limit)
  form.searchQuery = next
  el.value = next
  showSearchLimitToast()
}

function trimSearchQueryToFieldLimit(field: OrderSearchField = form.searchField): void {
  const limit = searchQueryLimitForField(field)
  if (form.searchQuery.length <= limit) return
  form.searchQuery = form.searchQuery.slice(0, limit)
  showSearchLimitToast(field)
}

function filterServiceStatusMenuOptions(options: { value: string; label: string }[]) {
  return options.filter((x) => {
    if (x.label.trim() === 'FU-Pending') return false
    const v = String(x.value).trim().toLowerCase().replace(/[\s-]+/g, '_')
    return v !== 'fu_pending'
  })
}

/** FU 子页固定 9 项；主列表下拉与卡片页头 Service Status 对齐 */
const serviceStatusMenuOptions = computed(() => {
  const options = isFuSpecialFilterView.value
    ? FALLBACK_STATUS_OPTIONS
    : CARD_ALIGNED_SERVICE_STATUS_OPTIONS
  return filterServiceStatusMenuOptions(options)
})

const serviceStatusDisplay = computed(() => {
  const row = serviceStatusMenuOptions.value.find((x) => x.value === form.serviceStatus)
  return row?.label ?? form.serviceStatus
})

const form = reactive({
  searchField: 'order_id' as OrderSearchField,
  searchQuery: '',
  serviceDate: '',
  followUpDate: '',
  serviceStatus: 'all',
  technicianId: 'All',
  technicianName: 'All',
  inspectorId: 'All',
  inspectorName: 'All',
})

function formatYmdAsUsLong(ymd: string): string | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd.trim())
  if (!m) return null
  const y = Number(m[1])
  const mo = Number(m[2])
  const d = Number(m[3])
  const dt = new Date(y, mo - 1, d)
  if (Number.isNaN(dt.getTime())) return null
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

const MONTH_ABBR_TO_NUM: Record<string, number> = {
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  jun: 6,
  jul: 7,
  aug: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dec: 12,
}

function parseYmdQuery(ymd: string): { y: number; mo: number; d: number } | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd.trim())
  if (!m) return null
  const y = Number(m[1])
  const mo = Number(m[2])
  const d = Number(m[3])
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return null
  return { y, mo, d }
}

/** 从时段文案中解析日历日（ISO、May 08, 2026 等），与 YYYY-MM-DD 查询比对 */
function textContainsCalendarYmd(text: string, target: { y: number; mo: number; d: number }): boolean {
  const s = text.trim()
  if (!s) return false
  for (const m of s.matchAll(/(\d{4})-(\d{2})-(\d{2})/g)) {
    if (Number(m[1]) === target.y && Number(m[2]) === target.mo && Number(m[3]) === target.d) return true
  }
  for (const m of s.matchAll(/\b([A-Za-z]{3})[a-z]*\s+(\d{1,2}),\s*(\d{4})\b/g)) {
    const mo = MONTH_ABBR_TO_NUM[m[1]!.slice(0, 3).toLowerCase()]
    if (!mo) continue
    if (Number(m[3]) === target.y && mo === target.mo && Number(m[2]) === target.d) return true
  }
  return false
}

function scheduledAtContainsYmd(scheduledAt: string | null | undefined, ymd: string): boolean {
  if (!ymd.trim() || !scheduledAt) return false
  const s = scheduledAt.trim()
  if (s === 'Pending Schedule' || s === 'Pending Reschedule') return false
  const target = parseYmdQuery(ymd)
  if (target && textContainsCalendarYmd(s, target)) return true
  const us = formatYmdAsUsLong(ymd)
  if (us) {
    if (s.includes(us)) return true
    const dayMatch = /^([A-Za-z]{3})\s+(\d{1,2}),\s*(\d{4})$/.exec(us)
    if (dayMatch) {
      const padded = `${dayMatch[1]} ${String(Number(dayMatch[2])).padStart(2, '0')}, ${dayMatch[3]}`
      if (padded !== us && s.includes(padded)) return true
    }
  }
  return s.includes(ymd.trim())
}

/** 与卡片小图标悬停层一致：原始时段 + formatOrderScheduleLineDisplay 后的展示文案 */
function careOrderScheduleSearchTextVariants(raw: string): string[] {
  const t = raw.trim()
  if (!t || t === '—') return []
  const formatted = formatOrderScheduleLineDisplay(t)
  if (!formatted || formatted === '—' || formatted === t) return [t]
  return [t, formatted]
}

/** 服务行已排期 + 小图标悬停层（首选时间 / 演示时段等，与 scheduleGlyphTooltipEntries 同源） */
function lineScheduleSearchMatchesYmd(order: OrderCardDTO, line: OrderServiceLineDTO, ymd: string): boolean {
  const texts: string[] = []
  for (const chunk of careOrderScheduleSearchTextVariants(line.scheduledAt ?? '')) texts.push(chunk)
  for (const pt of orderPreferredTimesList(order)) {
    for (const chunk of careOrderScheduleSearchTextVariants(pt)) texts.push(chunk)
  }
  for (const entry of scheduleGlyphTooltipEntries(order, line)) {
    for (const chunk of careOrderScheduleSearchTextVariants(entry)) texts.push(chunk)
  }
  return texts.some((entry) => scheduledAtContainsYmd(entry, ymd))
}

function findFollowUpCareLine(order: OrderCardDTO): OrderServiceLineDTO | null {
  return order.services.find((l) => isFollowUpCareLine(l)) ?? null
}

/** Follow-up Date：与跟进行卡片悬停小图标同源（首选时间 / 演示时段 / 已排期文案） */
function followUpLineScheduleSearchTexts(order: OrderCardDTO, line: OrderServiceLineDTO): string[] {
  const texts = new Set<string>()
  const addRaw = (raw: string) => {
    for (const chunk of careOrderScheduleSearchTextVariants(raw)) texts.add(chunk)
  }
  if (followUpRowShowsPreferredRescheduleBlock(order, line)) {
    for (const pt of orderPreferredTimesList(order)) addRaw(pt)
    return [...texts]
  }
  if (lineShowsPreferredTimeScheduleGlyph(line, order)) {
    for (const entry of scheduleGlyphTooltipEntries(order, line)) addRaw(entry)
  }
  addRaw(line.scheduledAt ?? '')
  const displayed = formatSvcTimeDisplay(line, order)
  if (displayed && displayed !== '—' && !/^pending/i.test(displayed)) {
    addRaw(displayed)
  }
  return [...texts]
}

function orderMatchesFollowUpDateYmd(order: OrderCardDTO, ymd: string): boolean {
  const fu = findFollowUpCareLine(order)
  if (!fu) return false
  return followUpLineScheduleSearchTexts(order, fu).some((entry) => scheduledAtContainsYmd(entry, ymd))
}

function orderMatchesCareServiceDateYmd(order: OrderCardDTO, ymd: string): boolean {
  for (let i = 0; i < order.services.length; i++) {
    const line = mergedCareLine(order, i as 0 | 1)
    if (isFollowUpCareLine(line)) {
      if (
        !lineShowsPreferredTimeScheduleGlyph(line, order) &&
        !followUpRowShowsPreferredRescheduleBlock(order, line)
      ) {
        continue
      }
    }
    if (lineScheduleSearchMatchesYmd(order, line, ymd)) return true
  }
  return false
}

function canonServiceStatusLabel(s: string): string {
  return s
    .trim()
    .toLowerCase()
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/^fu\s+/i, 'follow up ')
}

function normalizeServiceStatusApiCode(input: string): string {
  const k = careOrderListServiceStatusApiParam(input).trim().toLowerCase().replace(/[\s-]+/g, '_')
  if (k === 'follow_up_pending_schedule') return 'fu_pending_schedule'
  if (k === 'follow_up_pending_reschedule') return 'fu_pending_reschedule'
  if (k === 'follow_up_assigned') return 'fu_assigned'
  if (k === 'follow_up_completed') return 'fu_completed'
  return k
}

/** 与卡片页头 Service Status 对齐的 API 枚举（用于筛选比对） */
function resolveOrderCardFilterStatusCode(order: OrderCardDTO): string {
  const head = resolveOrderCardHeadServiceStatus(order)
  const fromHead = normalizeServiceStatusApiCode(head)
  if (fromHead && fromHead !== 'all') return fromHead
  const stored = (order.serviceStatusCode ?? '').trim()
  if (stored) return normalizeServiceStatusApiCode(stored)
  return normalizeServiceStatusApiCode(order.status ?? '')
}

function orderMatchesServiceStatusFilter(order: OrderCardDTO, filterValue: string): boolean {
  if (filterValue === 'all') return true
  const filterCode = normalizeServiceStatusApiCode(filterValue)
  if (!filterCode) return true

  const stored = (order.serviceStatusCode ?? '').trim()
  if (stored && normalizeServiceStatusApiCode(stored) === filterCode) return true

  const orderCode = resolveOrderCardFilterStatusCode(order)
  if (orderCode === filterCode) return true

  const bucket = classifyCareOrderCardBucket(order)
  if (bucket && normalizeServiceStatusApiCode(CARE_SIDEBAR_SUB_BUCKET_API_STATUS[bucket]) === filterCode) {
    return true
  }

  if (filterCode === 'pending_reschedule' && orderIsMainPendingRescheduleOrder(order)) return true
  if (filterCode === 'fu_pending_reschedule' && orderIsFuPendingRescheduleOrder(order)) return true
  if (filterCode === 'fu_pending_schedule' && orderIsFuPendingScheduleOrder(order)) return true
  if (filterCode === 'pending_schedule' && orderCardIsMainPendingSchedule(order)) return true

  const expectedLabel =
    careServiceStatusCodeToDisplayLabel(filterValue) ??
    serviceStatusMenuOptions.value.find((x) => x.value === filterValue)?.label ??
    ''
  if (!expectedLabel.trim()) return true
  const head = resolveOrderCardHeadServiceStatus(order)
  return canonServiceStatusLabel(head) === canonServiceStatusLabel(expectedLabel)
}

function orderMatchesSearchField(order: OrderCardDTO, field: OrderSearchField, q: string): boolean {
  const raw = q.trim()
  if (!raw) return true
  const n = raw.toLowerCase()
  const lc = (s: string | undefined | null) => (s ?? '').toLowerCase()
  const addrBlob = order.services.map((l) => l.address).join(' ')
  const codeBlob = order.services.map((l) => l.productCode).join(' ')
  switch (field) {
    case 'order_id':
      return lc(order.id).includes(n)
    case 'home_id':
    case 'user_id':
      return lc(order.homeId).includes(n)
    case 'contact_phone_number':
      return lc(order.notes).includes(n) || lc(addrBlob).includes(n) || lc(order.placementDate).includes(n)
    case 'address':
      return lc(addrBlob).includes(n)
    case 'subscription_id':
      return lc(codeBlob).includes(n) || lc(order.notes).includes(n)
    case 'report_id':
      return lc(codeBlob).includes(n) || lc(order.id).includes(n) || lc(order.notes).includes(n)
    case 'follow_up_id': {
      const fu = order.services.find((l) => isFollowUpCareLine(l))
      const fuBlob = fu ? [fu.productCode, fu.scheduledAt ?? '', fu.serviceName].join(' ') : ''
      return lc(fuBlob).includes(n) || lc(order.id).includes(n)
    }
    default:
      return false
  }
}

function orderMatchesTechnicianFilter(order: OrderCardDTO): boolean {
  if (form.technicianId === 'All') return true
  const name = (form.technicianName || '').trim().toLowerCase()
  const id = (form.technicianId || '').trim().toLowerCase()
  for (const line of order.services) {
    const a = (line.assignment || '').trim().toLowerCase()
    const ref = (line.technicianRef || '').trim().toLowerCase()
    if (name && (a.includes(name) || ref.includes(name))) return true
    if (id && id !== 'all' && (ref.includes(id) || a.includes(id))) return true
  }
  return false
}

function orderMatchesInspectorFilter(order: OrderCardDTO): boolean {
  if (form.inspectorId === 'All') return true
  const name = (form.inspectorName || '').trim().toLowerCase()
  const id = (form.inspectorId || '').trim().toLowerCase()
  if (!name && (!id || id === 'all')) return true
  for (const line of order.services) {
    const a = (line.assignment || '').trim().toLowerCase()
    const ref = (line.technicianRef || '').trim().toLowerCase()
    if (name && (a.includes(name) || ref.includes(name))) return true
    if (id && id !== 'all' && (ref.includes(id) || a.includes(id))) return true
  }
  return false
}

/** 按 Service Date / Follow-up Date 筛选；待排期时段在小图标悬停层时也参与匹配 */
function applyCareOrderDateFilters(list: OrderCardDTO[]): OrderCardDTO[] {
  if (!form.serviceDate.trim() && !form.followUpDate.trim()) return list
  return list.filter((order) => {
    if (form.serviceDate.trim() && !orderMatchesCareServiceDateYmd(order, form.serviceDate)) {
      return false
    }
    if (form.followUpDate.trim() && !orderMatchesFollowUpDateYmd(order, form.followUpDate)) {
      return false
    }
    return true
  })
}

/** 本地 DEV 注入八条模板时：按表单在浏览器侧筛选（接口结果在此模式下被替换，原先搜什么都是八条） */
function applyCareOrderClientFilters(list: OrderCardDTO[]): OrderCardDTO[] {
  return list.filter((order) => {
    if (!orderMatchesSearchField(order, form.searchField, form.searchQuery)) return false
    if (!orderMatchesServiceStatusFilter(order, form.serviceStatus)) return false
    if (!orderMatchesTechnicianFilter(order)) return false
    // HM Care Orders 根目录无 Inspector 筛选项，避免从子目录遗留的 inspector 条件误滤掉 FU 单
    if (props.careSubKey !== 'hm_orders' && !orderMatchesInspectorFilter(order)) return false
    return true
  })
}

const page = ref(1)
const pageSize = ref(10)
const total = ref(0)
const orders = ref<OrderCardDTO[]>([])
let loadOrdersGeneration = 0
const technicians = ref<Technician[]>([])
/** 技术员 list 的 license_no（TechniciansPage.vue 绿色执照号），不改 api 层 */
const technicianNoLookup = ref<TechnicianNoLookup | null>(null)
const loading = ref(false)
const gotoVal = ref(1)

const noteModalOpen = ref(false)
const noteDraft = ref('')
const noteTarget = ref<{ order: OrderCardDTO; lineIndex: number } | null>(null)
const noteSaving = ref(false)

const refundModalOpen = ref(false)
const refundTarget = ref<{ order: OrderCardDTO; line: OrderServiceLineDTO; lineIndex: number } | null>(
  null,
)
const refundSaving = ref(false)
const refundContextLoading = ref(false)
const refundAmountPaid = ref('$0.00')
const refundableAmountDisplay = ref('$0.00')
const refundedAmountDisplay = ref('$0.00')
const refundTaxRate = ref(0)
const refundTaxOptions = ref<RefundTaxOption[]>([...DEFAULT_REFUND_TAX_OPTIONS])

const refundOrderPrimaryId = computed(() => {
  const pk = refundTarget.value?.order.orderPrimaryId
  return pk != null && Number.isFinite(pk) && pk > 0 ? pk : null
})

function resetRefundContextDisplay() {
  refundAmountPaid.value = '$0.00'
  refundableAmountDisplay.value = '$0.00'
  refundedAmountDisplay.value = '$0.00'
  refundTaxRate.value = 0
  refundTaxOptions.value = [...DEFAULT_REFUND_TAX_OPTIONS]
}

async function loadRefundContextForTarget(
  order: OrderCardDTO,
  lineIndex: number,
): Promise<boolean> {
  const pk = order.orderPrimaryId
  if (pk == null || !Number.isFinite(pk) || pk <= 0) {
    resetRefundContextDisplay()
    emit('toast', { type: 'error', message: 'Order id missing for refund' })
    return false
  }

  refundContextLoading.value = true
  try {
    const [metaRes, contextRes] = await Promise.all([
      postCareOrderRefundMeta({ id: pk, line_index: lineIndex }),
      postCareOrderRefundContext({ id: pk, line_index: lineIndex }),
    ])

    if (metaRes.code === 200) {
      refundTaxOptions.value = buildRefundTaxOptions(metaRes.data)
      const metaRate = parseRefundTaxRate(metaRes.data?.tax_rate)
      if (metaRate > 0) refundTaxRate.value = metaRate
    } else {
      refundTaxOptions.value = [...DEFAULT_REFUND_TAX_OPTIONS]
    }

    if (contextRes.code === 200 && contextRes.data) {
      const data = contextRes.data
      refundAmountPaid.value = formatRefundMoney(data.amount_paid)
      refundableAmountDisplay.value = formatRefundMoney(data.refundable_amount)
      refundedAmountDisplay.value = formatRefundMoney(data.refunded_amount)
      const ctxRate = parseRefundTaxRate(data.tax_rate)
      if (ctxRate > 0) refundTaxRate.value = ctxRate
      return true
    }

    resetRefundContextDisplay()
    emit('toast', {
      type: 'error',
      message: contextRes.msg || 'Failed to load refund context',
    })
    return false
  } catch (e: unknown) {
    console.error('Failed to load refund context:', e)
    resetRefundContextDisplay()
    emit('toast', { type: 'error', message: apiErrorMessage(e) })
    return false
  } finally {
    refundContextLoading.value = false
  }
}
let lastNoteLimitToastAt = 0

function showNoteLimitToast(): void {
  const now = Date.now()
  if (now - lastNoteLimitToastAt < 1200) return
  lastNoteLimitToastAt = now
  emit('toast', {
    type: 'warning',
    message: fieldLimitError('Notes', orderFieldLimits.notes),
  })
}

function onNoteDraftInput(e: Event): void {
  const el = e.target as HTMLTextAreaElement
  const limit = orderFieldLimits.notes
  let next = el.value
  if (next.length > limit) {
    next = next.slice(0, limit)
    el.value = next
    showNoteLimitToast()
  }
  noteDraft.value = next
}

function onNoteDraftPaste(e: ClipboardEvent): void {
  const paste = e.clipboardData?.getData('text') ?? ''
  if (!paste) return
  const limit = orderFieldLimits.notes
  const el = e.target as HTMLTextAreaElement
  const start = el.selectionStart ?? noteDraft.value.length
  const end = el.selectionEnd ?? start
  const merged = noteDraft.value.slice(0, start) + paste + noteDraft.value.slice(end)
  if (merged.length <= limit) return
  e.preventDefault()
  const next = merged.slice(0, limit)
  noteDraft.value = next
  el.value = next
  showNoteLimitToast()
}

const now = new Date()
const calMonthSvc = ref(now.getMonth())
const calYearSvc = ref(now.getFullYear())
const calMonthFu = ref(now.getMonth())
const calYearFu = ref(now.getFullYear())

function goNewOrderPage() {
  void router.push(careOrdersNewRoute())
}

function onNewOrderRefresh() {
  page.value = 1
  clearHmOrdersAllMergedCache()
  void loadOrders().then(() => {
    refreshSidebarBadgesNow()
  })
}

function onNewOrderLocalInsert() {
  if (props.careSubKey === 'hm_orders') {
    prependOrderFromCareInsertLocalIfPresent({ requireRouteQuery: false })
    refreshSidebarBadgesNow()
    return
  }
  page.value = 1
  void loadOrders().then(() => {
    refreshSidebarBadgesNow()
  })
}

function syncSidebarFromList(list: OrderCardDTO[]) {
  if (!careOrdersRef) return
  careOrdersRef.value = list.map(orderCardDtoToSidebarRecord)
}

function normalizeOrdersResponseForMerge(
  raw: unknown,
): { list: OrderCardDTO[]; total: number; totalPages: number } {
  const lookup = technicianNoLookup.value

  if (raw != null && typeof raw === 'object') {
    const r = raw as Record<string, unknown>
    if (r.code === 200 && r.data != null && typeof r.data === 'object') {
      const data = r.data as Record<string, unknown>
      const listRaw = extractCareOrderListArray(data)
      if (listRaw) {
        const list = mapCareOrderListToCardsRaw(listRaw, lookup)
        return {
          list,
          total: readCareOrderListTotal(data, list.length),
          totalPages: readCareOrderListPageCount(data),
        }
      }
    }
  }

  const parsed = normalizeOrdersResponse(raw)
  return { ...parsed, totalPages: 0 }
}

function careOrderRowKey(o: OrderCardDTO): string {
  const pk = o.orderPrimaryId
  if (pk != null && Number.isFinite(pk)) return `pk:${pk}`
  const id = (o.id ?? '').trim()
  if (id && id !== '—') return `id:${id}`
  return `anon:${(o.homeId ?? '').trim()}:${(o.placementDate ?? '').trim()}`
}

function preferCareOrderCard(existing: OrderCardDTO, incoming: OrderCardDTO): OrderCardDTO {
  const isSynthetic = (o: OrderCardDTO) => {
    const id = (o.id ?? '').trim()
    const pk = o.orderPrimaryId
    if (!id || id === '—') return true
    if (pk != null && (id === `HM-${pk}` || id === String(pk))) return true
    return false
  }
  if (isSynthetic(existing) && !isSynthetic(incoming)) return incoming
  if (isSynthetic(incoming) && !isSynthetic(existing)) return existing

  const rank = (o: OrderCardDTO): number => {
    const code = (o.serviceStatusCode ?? '').trim().toLowerCase()
    if (code === 'fu_pending_schedule') return 30
    if (code === 'fu_pending_reschedule') return 28
    if (code === 'pending_schedule') return 27
    const bucket = classifyCareSidebarSubBucket(o.status ?? '')
    if (bucket === 'fu_pend_sched') return 25
    if (bucket === 'fu_pend_resched') return 23
    if (bucket === 'pend_sched') return 22
    return 0
  }
  const rExisting = rank(existing)
  const rIncoming = rank(incoming)
  if (rIncoming !== rExisting) return rIncoming > rExisting ? incoming : existing
  return incoming
}

function careOrderCardsReferToSameOrder(a: OrderCardDTO, b: OrderCardDTO): boolean {
  const idA = (a.id ?? '').trim()
  const idB = (b.id ?? '').trim()
  if (idA && idB && idA === idB) return true
  const pkA = a.orderPrimaryId
  const pkB = b.orderPrimaryId
  return pkA != null && pkB != null && pkA === pkB
}

function lineScheduleFieldsFromPatch(
  existing: OrderServiceLineDTO,
  patchLine: OrderServiceLineDTO,
): OrderServiceLineDTO {
  const sched = (patchLine.scheduledAt ?? '').trim()
  const isPendingSchedule = /pending\s+schedule/i.test(sched)
  const isPendingReschedule = /pending\s+reschedule/i.test(sched)
  const hasBookedSlot =
    !!sched &&
    !/pending\s+(schedule|reschedule)/i.test(sched) &&
    /(\d{1,2}:\d{2})\s*(AM|PM)/i.test(sched) &&
    (/\d{4}-\d{2}-\d{2}/.test(sched) || /[A-Za-z]{3}\s+\d{1,2},?\s*\d{4}/.test(sched))

  const mergeAssignment = (): string => {
    const patchAssign = (patchLine.assignment ?? '').trim()
    const existingAssign = (existing.assignment ?? '').trim()
    if (
      isPendingAssignmentLabel(patchAssign) &&
      existingAssign &&
      !isPendingAssignmentLabel(existingAssign)
    ) {
      return existing.assignment!
    }
    return patchLine.assignment ?? existing.assignment
  }

  const mergeTechnicianRef = (): string | undefined => {
    const patchRef = (patchLine.technicianRef ?? '').trim()
    const existingRef = (existing.technicianRef ?? '').trim()
    if (patchRef) return patchLine.technicianRef
    if (
      isPendingAssignmentLabel(patchLine.assignment) &&
      existingRef &&
      hasBookedSlot
    ) {
      const keptAssign = mergeAssignment()
      if (keptAssign && !isPendingAssignmentLabel(keptAssign)) return existing.technicianRef
    }
    return patchLine.technicianRef ?? existing.technicianRef
  }

  if (isPendingSchedule || isPendingReschedule) {
    return {
      ...existing,
      scheduledAt: patchLine.scheduledAt,
      assignment: patchLine.assignment ?? existing.assignment ?? 'Pending Assignment',
      technicianRef: isPendingAssignmentLabel(patchLine.assignment)
        ? undefined
        : (patchLine.technicianRef ?? existing.technicianRef),
      canSchedule: isPendingSchedule
        ? true
        : isPendingReschedule
          ? false
          : (patchLine.canSchedule ?? existing.canSchedule),
      canReschedule: isPendingReschedule
        ? true
        : isPendingSchedule
          ? false
          : (patchLine.canReschedule ?? existing.canReschedule),
    }
  }

  if (hasBookedSlot) {
    return {
      ...existing,
      scheduledAt: patchLine.scheduledAt,
      assignment: mergeAssignment(),
      technicianRef: mergeTechnicianRef(),
      canSchedule: patchLine.canSchedule ?? false,
      canReschedule: patchLine.canReschedule ?? true,
    }
  }
  if (!sched || sched === '—') {
    if (isPendingAssignmentLabel(patchLine.assignment)) {
      return {
        ...existing,
        scheduledAt: patchLine.scheduledAt ?? existing.scheduledAt,
        assignment: patchLine.assignment,
        technicianRef: undefined,
        canSchedule: patchLine.canSchedule ?? true,
        canReschedule: patchLine.canReschedule ?? false,
      }
    }
    return existing
  }
  return existing
}

/** 排程写回：接口快照更新排程字段，缺字段时保留列表原展示 */
function mergeScheduleOrderPatch(existing: OrderCardDTO, patch: OrderCardDTO): OrderCardDTO {
  const merged = mergeCareOrderCardPreservingLocalFields(existing, patch)
  const maxLen = Math.max(merged.services.length, patch.services.length)
  const services: OrderServiceLineDTO[] = []
  for (let i = 0; i < maxLen; i++) {
    const prev = merged.services[i]
    const next = patch.services[i]
    if (!prev) {
      if (next) services.push(next)
      continue
    }
    if (!next) {
      services.push(prev)
      continue
    }
    services.push(lineScheduleFieldsFromPatch(prev, next))
  }
  const listId = (existing.id ?? '').trim() || (merged.id ?? '').trim()
  const patched: OrderCardDTO = {
    ...merged,
    id: listId || merged.id,
    status: patch.status?.trim() ? patch.status : merged.status,
    serviceStatusCode: patch.serviceStatusCode ?? merged.serviceStatusCode,
    services,
  }
  let result = normalizeOrderCardForDisplay(patched) ?? patched
  const hasMainAndFu =
    existing.services.some((l) => isFollowUpCareLine(l)) &&
    existing.services.some((l) => !isFollowUpCareLine(l))
  if (hasMainAndFu) {
    result = preserveMainLineOnMergedFollowUpCard(existing, result)
  }
  return result
}

/** 多路列表按主键并集合并（主列表 + FU / 各 status 分桶），避免 dedupe 把仅出现在分桶里的单弄丢 */
function unionMergeCareOrderLists(...parts: OrderCardDTO[][]): OrderCardDTO[] {
  const map = new Map<string, OrderCardDTO>()
  for (const part of parts) {
    for (const o of part) {
      const key = careOrderRowKey(o)
      const prev = map.get(key)
      map.set(key, prev ? preferCareOrderCard(prev, o) : o)
    }
  }
  return [...map.values()]
}

function dedupeCareOrderCardsById(list: OrderCardDTO[]): OrderCardDTO[] {
  return unionMergeCareOrderLists(list)
}

function normalizeOrdersResponse(raw: unknown): { list: OrderCardDTO[]; total: number } {
  const lookup = technicianNoLookup.value

  if (raw != null && typeof raw === 'object') {
    const r = raw as Record<string, unknown>
    if (r.code === 200 && r.data != null && typeof r.data === 'object') {
      const data = r.data as Record<string, unknown>
      const listRaw = extractCareOrderListArray(data)
      if (listRaw) {
        const list = mapCareOrderListToCards(listRaw, lookup)
        return { list, total: readCareOrderListTotal(data, list.length) }
      }
    }
  }

  const adminList = parseCareOrderListResponse(raw)
  if (adminList) {
    const list = lookup
      ? adminList.list.map((o) => applyTechnicianRefsToOrderCard(o, lookup))
      : adminList.list
    return { list, total: adminList.total }
  }

  if (raw == null) return { list: [], total: 0 }
  if (Array.isArray(raw)) {
    const list = lookup
      ? (raw as OrderCardDTO[]).map((o) => applyTechnicianRefsToOrderCard(o, lookup))
      : (raw as OrderCardDTO[])
    return { list, total: list.length }
  }

  const r = raw as Record<string, unknown>
  const inner = (r.data ?? r) as Record<string, unknown>
  const list = (inner.list ?? inner.records ?? r.list) as OrderCardDTO[] | undefined
  if (list && Array.isArray(list)) {
    const t = readCareOrderListTotal(inner, list.length)
    const patched = lookup ? list.map((o) => applyTechnicianRefsToOrderCard(o, lookup)) : list
    return { list: patched, total: t }
  }

  return { list: [], total: 0 }
}

const orderListCount = computed(() => total.value)

const pagedOrders = computed(() => normalizeOrderCardListForDisplay(orders.value))

const totalPages = computed(() => Math.max(1, Math.ceil(total.value / pageSize.value)))

const pageButtons = computed(() => {
  const maxBtn = 5
  const tp = totalPages.value
  if (tp <= maxBtn) return Array.from({ length: tp }, (_, i) => i + 1)
  const start = Math.max(1, Math.min(page.value - 2, tp - maxBtn + 1))
  const end = Math.min(tp, start + maxBtn - 1)
  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
})

const technicianLabel = computed(() => form.technicianName)
const inspectorLabel = computed(() => form.inspectorName)

type StatusSearchNavIntent = {
  targetSub: CareSubKey
  preserveServiceStatus?: string
}

let pendingStatusSearchNav: StatusSearchNavIntent | null = null

/** 切换 Care 子页时清空搜索栏（关键词、日期），不动技术员/检查员/Service Status 等 */
function resetSearchBarOnSubPageChange() {
  form.searchField = 'order_id'
  form.searchQuery = ''
  form.serviceDate = ''
  form.followUpDate = ''
  clearHmOrdersAllMergedCache()
}

function applyCareSubKey(key: CareOrdersSubKey) {
  form.inspectorId = 'All'
  form.inspectorName = 'All'
  if (key === 'hm_orders') {
    // 根目录 = 全集：进入时清掉四子目录遗留的 Service Status / Inspector 筛选
    form.serviceStatus = 'all'
    form.inspectorId = 'All'
    form.inspectorName = 'All'
    clearHmOrdersAllMergedCache()
    return
  }
  if (isCareOrdersFourSubKey(key)) {
    form.serviceStatus = CARE_SIDEBAR_SUB_BUCKET_API_STATUS[key]
  }
}

watch(
  () => props.careSubKey,
  (key) => {
    if (pendingStatusSearchNav && key === pendingStatusSearchNav.targetSub) {
      const intent = pendingStatusSearchNav
      pendingStatusSearchNav = null
      const savedInspectorId = form.inspectorId
      const savedInspectorName = form.inspectorName
      applyCareSubKey(key)
      form.inspectorId = savedInspectorId
      form.inspectorName = savedInspectorName
      if (intent.preserveServiceStatus) {
        form.serviceStatus = intent.preserveServiceStatus
      }
      page.value = 1
      openDd.value = null
      openCal.value = null
      void loadOrders({ fromSearch: true })
      return
    }
    pendingStatusSearchNav = null
    applyCareSubKey(key)
    // Users 等外链仍有 list prefill 时，勿清空搜索栏，改为消费后再拉列表
    const pendingPrefill = peekHmCareOrdersListPrefill()
    if (pendingPrefill?.searchField && pendingPrefill?.searchQuery) {
      tryConsumeCareOrdersListPrefill()
    } else {
      resetSearchBarOnSubPageChange()
    }
    page.value = 1
    openDd.value = null
    openCal.value = null
    void loadOrders()
  },
)

watch(
  () => route.query.careRefresh,
  (v) => {
    if (v !== '1') return
    page.value = 1
    void loadOrders()
  },
)

function toggleDd(which: 'field' | 'status' | 'tech' | 'insp') {
  openDd.value = openDd.value === which ? null : which
  openCal.value = null
}

function selectSearchField(key: OrderSearchField) {
  form.searchField = key
  trimSearchQueryToFieldLimit(key)
  openDd.value = null
}

function selectStatus(value: string) {
  form.serviceStatus = value
  openDd.value = null
}

function selectTechnician(id: string, name: string) {
  form.technicianId = id
  form.technicianName = name
  openDd.value = null
}

function selectInspector(id: string, name: string) {
  form.inspectorId = id
  form.inspectorName = name
  openDd.value = null
}

function openCalKey(key: 'service' | 'followup') {
  openCal.value = openCal.value === key ? null : key
  openDd.value = null
}

function onPickDate(which: 'service' | 'followup', ymd: string) {
  if (which === 'service') form.serviceDate = ymd
  else form.followUpDate = ymd
  openCal.value = null
}

function clearFilters() {
  form.searchField = 'order_id'
  form.searchQuery = ''
  form.serviceDate = ''
  form.followUpDate = ''
  form.serviceStatus = isCareOrdersFourSubKey(props.careSubKey)
    ? CARE_SIDEBAR_SUB_BUCKET_API_STATUS[props.careSubKey]
    : 'all'
  form.technicianId = 'All'
  form.technicianName = 'All'
  form.inspectorId = 'All'
  form.inspectorName = 'All'
  page.value = 1
  openDd.value = null
  openCal.value = null
  clearHmOrdersAllMergedCache()
  void loadOrders()
}

function runSearch() {
  const limitErr = validateSearchQueryLength()
  if (limitErr) {
    emit('toast', { type: 'warning', message: limitErr })
    return
  }
  page.value = 1
  clearHmOrdersAllMergedCache()

  if (props.careSubKey === 'hm_orders' || isCareOrdersFourSubKey(props.careSubKey)) {
    const targetSub = careSubKeyForServiceStatusFilter(form.serviceStatus)
    if (targetSub !== props.careSubKey) {
      pendingStatusSearchNav = {
        targetSub,
        preserveServiceStatus:
          targetSub === 'hm_orders' && form.serviceStatus !== 'all'
            ? form.serviceStatus
            : undefined,
      }
      void router.push(careOrdersListRouteForSub(targetSub))
      return
    }
  }

  void loadOrders({ fromSearch: true })
}

function scrollOrdersListToTop() {
  void nextTick(() => {
    const host = rootRef.value
    if (!host) return
    const titleBar = host.querySelector('.page-title-bar')
    const top = titleBar instanceof HTMLElement ? titleBar.offsetHeight : 0
    window.scrollTo({ top, left: 0 })
  })
}

function goPage(p: number) {
  const tp = totalPages.value
  page.value = Math.min(tp, Math.max(1, Math.floor(Number(p)) || 1))
  gotoVal.value = page.value
  void loadOrders().then(scrollOrdersListToTop)
}

function syncHmCareOrdersPageChrome() {
  syncSidebarFromList(orders.value)
  clampCareOrdersPageToTotal()
}

function clampCareOrdersPageToTotal() {
  const tp = totalPages.value
  if (page.value > tp) page.value = tp
  gotoVal.value = page.value
}

function normalizeTechnicianRow(row: unknown): Technician | null {
  if (!row || typeof row !== 'object') return null
  const o = row as Record<string, unknown>
  const id = o.id ?? o.technicianId ?? o.userId ?? o.value
  const name = o.name ?? o.username ?? o.fullName ?? o.label
  if (name == null) return null
  return { id: id != null ? String(id) : String(name), name: String(name) }
}

async function loadTechnicianNoLookupFromList(): Promise<TechnicianNoLookup | null> {
  try {
    const list = await fetchActiveTechnicianList()
    if (!list.length) return null
    technicians.value = list
      .filter((item) => (item.name ?? '').trim())
      .map((item) => ({ id: String(item.id), name: String(item.name).trim() }))
    return buildTechnicianNoLookup(list)
  } catch {
    return null
  }
}

async function loadCareMeta() {
  try {
    const [meta, lookup] = await Promise.all([postCareOrderMeta(), loadTechnicianNoLookupFromList()])
    technicianNoLookup.value = lookup
    careMeta.value = meta
    if (!technicians.value.length) {
      technicians.value = meta.technicians
        .filter((t) => Number(t.value) !== 0)
        .map((t) => ({ id: String(t.value), name: String(t.label) }))
    }
  } catch {
    careMeta.value = null
    technicianNoLookup.value = null
    await loadTechnicians()
  }
}

async function loadTechnicians() {
  try {
    const lookup = await loadTechnicianNoLookupFromList()
    technicianNoLookup.value = lookup
    if (technicians.value.length) return
    if (!careMeta.value) careMeta.value = await postCareOrderMeta()
    technicians.value = (careMeta.value?.technicians ?? [])
      .filter((t) => Number(t.value) !== 0)
      .map((t) => ({ id: String(t.value), name: String(t.label) }))
  } catch {
    technicians.value = []
    technicianNoLookup.value = null
  }
}

/** HM Care Orders 全集 + 四子目录：同一缓存，子目录仅按状态桶客户端筛选 */
function assignOrdersForCurrentSubView(rawList: OrderCardDTO[], serverTotal: number): void {
  const list = normalizeOrderCardListForDisplay(rawList)
  orders.value = list
  total.value = serverTotal
  syncSidebarFromList(list)
}

function stripCareReturnQueryKeys(keys: ('careRefresh' | 'careInsertLocal')[]) {
  const q = { ...route.query } as Record<string, string | string[] | undefined>
  let changed = false
  for (const k of keys) {
    if (k in q) {
      delete q[k]
      changed = true
    }
  }
  if (changed) void router.replace({ path: route.path, query: q })
}

function tryConsumeCareOrdersListPrefill(): boolean {
  const prefill = readHmCareOrdersListPrefill()
  if (!prefill) return false

  if (prefill.technicianId) {
    form.technicianId = prefill.technicianId
    form.technicianName = prefill.technicianName ?? prefill.technicianId
  } else if (prefill.inspectorId) {
    // HM Care Orders 主列表仅展示 Technician 筛选项，Inspector 跳转时映射到 Technician 筛选
    form.technicianId = prefill.inspectorId
    form.technicianName = prefill.inspectorName ?? prefill.inspectorId
    if (props.careSubKey !== 'hm_orders') {
      form.inspectorId = prefill.inspectorId
      form.inspectorName = prefill.inspectorName ?? prefill.inspectorId
    }
  }

  if (prefill.searchField && prefill.searchQuery) {
    form.searchField = prefill.searchField as OrderSearchField
    form.searchQuery = prefill.searchQuery
  }

  page.value = 1
  clearHmOrdersAllMergedCache()
  return true
}

function tryConsumeCareInsertLocalCard(opts?: { requireRouteQuery?: boolean }): OrderCardDTO | null {
  const requireRouteQuery = opts?.requireRouteQuery !== false
  if (requireRouteQuery && route.query.careInsertLocal !== '1') return null
  let card: OrderCardDTO | null = null
  try {
    const raw = sessionStorage.getItem(HM_CARE_ORDER_LOCAL_INSERT_KEY)
    if (raw) {
      sessionStorage.removeItem(HM_CARE_ORDER_LOCAL_INSERT_KEY)
      const parsed = JSON.parse(raw) as unknown
      if (parsed && typeof parsed === 'object' && parsed !== null) {
        const o = parsed as Partial<OrderCardDTO>
        if (typeof o.id === 'string' && Array.isArray(o.services)) card = o as OrderCardDTO
      }
    }
  } catch {
    /* ignore */
  }
  if (requireRouteQuery) stripCareReturnQueryKeys(['careInsertLocal'])
  return card
}

function prependOrderFromCareInsertLocalIfPresent(opts?: { requireRouteQuery?: boolean }) {
  if (props.careSubKey !== 'hm_orders') return
  const card = tryConsumeCareInsertLocalCard(opts)
  if (!card) return
  if (!normalizeOrderCardForDisplay(card)) return
  page.value = 1
  void loadOrders()
}

/** 排程弹层内实时写回：合并 assign/unassign 接口返回的订单快照到当前页列表 */
function mergeScheduleOrdersIntoCurrentList(patches: OrderCardDTO[]) {
  orders.value = orders.value.map((o) => {
    const patch = patches.find((p) => careOrderCardsReferToSameOrder(o, p))
    return patch ? mergeScheduleOrderPatch(o, patch) : o
  })
  for (const p of patches) {
    if (!orders.value.some((o) => careOrderCardsReferToSameOrder(o, p))) {
      orders.value = [...orders.value, p]
    }
  }
  orders.value = normalizeOrderCardListForDisplay(orders.value)
  syncSidebarFromList(orders.value)
}

function assertCareOrderListResponseOk(raw: unknown): void {
  if (raw == null || typeof raw !== 'object') return
  const r = raw as Record<string, unknown>
  if (typeof r.code !== 'number' || r.code === 200) return
  const msg =
    (typeof r.msg === 'string' && r.msg.trim()) ||
    (typeof r.message === 'string' && r.message.trim()) ||
    'Orders could not be loaded.'
  throw new Error(msg)
}

function careOrderListQueryFromForm(overrides?: Partial<OrderListQuery>): OrderListQuery {
  const subStatus = isCareOrdersFourSubKey(props.careSubKey)
    ? listServiceStatusForCareSubKey(props.careSubKey)
    : form.serviceStatus === 'all'
      ? undefined
      : careOrderListServiceStatusApiParam(form.serviceStatus)
  return {
    page: page.value,
    pageSize: pageSize.value,
    searchField: form.searchField,
    searchQuery: form.searchQuery.trim() || undefined,
    serviceDate: form.serviceDate.trim() || undefined,
    followUpDate: form.followUpDate.trim() || undefined,
    serviceStatus: subStatus,
    technicianId: form.technicianId === 'All' ? undefined : form.technicianId,
    inspectorId: form.inspectorId === 'All' ? undefined : form.inspectorId,
    ...overrides,
  }
}

/** 拉「全集」合并用：已废弃，保留空清理入口供筛选变化处调用 */
function clearHmOrdersAllMergedCache(_opts?: { keepFilteredView?: boolean }) {
  invalidateCareOrderListCache()
}

async function loadOrders(opts?: { fromSearch?: boolean }) {
  const limitErr = validateSearchQueryLength()
  if (limitErr) {
    emit('toast', { type: 'warning', message: limitErr })
    return
  }

  const generation = ++loadOrdersGeneration
  loading.value = true
  const fromSearch = opts?.fromSearch === true
  try {
    // Service Status / 四子页均走服务端分页（query 已带 service_status），不再客户端拉全集切片
    const raw = await fetchCareOrderListCached(careOrderListQueryFromForm(), {
      bypassCache: true,
    })
    if (generation !== loadOrdersGeneration) return
    assertCareOrderListResponseOk(raw)
    const { list: rawList, total: t } = normalizeOrdersResponse(raw)
    const list = normalizeOrderCardListForDisplay(rawList)
    assignOrdersForCurrentSubView(list, t)
    if (generation !== loadOrdersGeneration) return
    if (props.careSubKey === 'hm_orders') {
      prependOrderFromCareInsertLocalIfPresent()
    }
    clampCareOrdersPageToTotal()
    if (route.query.careRefresh === '1') {
      clearHmOrdersAllMergedCache()
      stripCareReturnQueryKeys(['careRefresh'])
    }
    if (fromSearch && list.length > 0) {
      emit('toast', { type: 'success', message: 'Search completed' })
    }
  } catch (e: unknown) {
    if (generation !== loadOrdersGeneration) return
    assignOrdersForCurrentSubView([], 0)
    clampCareOrdersPageToTotal()
    emit('toast', { type: 'warning', message: apiErrorMessage(e) })
  } finally {
    if (generation === loadOrdersGeneration) {
      loading.value = false
    }
  }
}

const lineActionBusy = ref<string | null>(null)

function lineActionBusyKey(orderId: string, lineIndex: number) {
  return `${orderId}:${lineIndex}`
}

function isLineActionBusy(orderId: string, lineIndex: number) {
  return lineActionBusy.value === lineActionBusyKey(orderId, lineIndex)
}

function apiErrorMessage(e: unknown): string {
  if (typeof e === 'object' && e !== null) {
    if ('msg' in e) {
      const m = (e as { msg: unknown }).msg
      if (typeof m === 'string' && m.trim()) return m.trim()
    }
    if ('response' in e) {
      const r = (e as { response?: { data?: unknown; statusText?: string } }).response
      const d = r?.data
      if (typeof d === 'string' && d.trim()) return d
      if (typeof d === 'object' && d !== null) {
        if ('msg' in d) {
          const m = (d as { msg: unknown }).msg
          if (typeof m === 'string' && m.trim()) return m.trim()
        }
        if ('message' in d) {
          const m = (d as { message: unknown }).message
          if (typeof m === 'string' && m.trim()) return m
        }
      }
      if (typeof r?.statusText === 'string' && r.statusText.trim()) return r.statusText
    }
  }
  if (e instanceof Error && e.message) return e.message
  return 'Request failed. Please try again.'
}

function lineActionSuccessMessage(action: 'schedule' | 'refund' | 'message' | 'note'): string {
  switch (action) {
    case 'schedule':
      return 'Schedule request sent.'
    case 'refund':
      return 'Successfully refunded'
    case 'message':
      return 'Message request sent.'
    case 'note':
      return 'Successfully saved'
    default:
      return 'Done.'
  }
}

async function refreshOrderInListFromDetail(
  order: OrderCardDTO,
  opts?: { preserveNotes?: string },
): Promise<boolean> {
  const key = props.careSubKey
  if (
    key === 'fu_pend_sched' ||
    key === 'fu_pend_resched' ||
    key === 'pend_sched' ||
    key === 'pend_resched'
  ) {
    await loadOrders()
    return true
  }
  if (order.orderPrimaryId == null) return false
  try {
    const row = await postCareOrderDetail(order.orderPrimaryId)
    const card = patchOrderCardTechnicianRefs(
      careOrderListItemToCardDto(row),
      row,
      technicianNoLookup.value,
    )
    const savedNotes = opts?.preserveNotes?.trim()
    if (savedNotes && !card.notes?.trim()) {
      card.notes = savedNotes
    }
    if (usesHmCareOrdersFullSet()) {
      mergeScheduleOrdersIntoCurrentList([card])
      return true
    }
    const idx = orders.value.findIndex((o) => careOrderCardsReferToSameOrder(o, order))
    if (idx < 0) return false
    orders.value[idx] = card
    syncSidebarFromList(orders.value)
    return true
  } catch {
    return false
  }
}

function patchOrderNotes(orderId: string, notes: string) {
  const apply = (o: OrderCardDTO): OrderCardDTO =>
    orderDisplayIdMatches(o, orderId) ? { ...o, notes } : o

  orders.value = orders.value.map(apply)

  if (
    orderDetailOverlayOrder.value &&
    orderDisplayIdMatches(orderDetailOverlayOrder.value, orderId)
  ) {
    orderDetailOverlayOrder.value = { ...orderDetailOverlayOrder.value, notes }
  }
}

function orderDisplayIdMatches(order: OrderCardDTO, orderId: string): boolean {
  const key = orderId.trim().toLowerCase()
  if (!key) return false
  const id = String(order.id ?? '').trim().toLowerCase()
  if (id === key) return true
  const pk = order.orderPrimaryId
  if (pk != null && Number.isFinite(pk)) {
    if (String(pk).toLowerCase() === key) return true
    if (`hm-${pk}`.toLowerCase() === key) return true
  }
  return false
}

function findOrderCardInLoadedCaches(orderId: string): OrderCardDTO | null {
  const pools = [orders.value]
  for (const pool of pools) {
    const hit = pool.find((o) => orderDisplayIdMatches(o, orderId))
    if (hit) return hit
  }
  return null
}

function readOrderDetailFocusFromSession(orderId: string): OrderCardDTO | null {
  try {
    const raw = sessionStorage.getItem(HM_CARE_ORDER_DETAIL_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    if (
      !parsed ||
      typeof parsed !== 'object' ||
      typeof (parsed as OrderCardDTO).id !== 'string' ||
      !Array.isArray((parsed as OrderCardDTO).services)
    ) {
      return null
    }
    const card = parsed as OrderCardDTO
    return orderDisplayIdMatches(card, orderId) ? card : null
  } catch {
    return null
  }
}

async function fetchOrderCardByDisplayId(orderId: string): Promise<OrderCardDTO | null> {
  const key = orderId.trim()
  if (!key) return null
  try {
    const raw = await fetchCareOrderListCached({
      page: 1,
      pageSize: 20,
      searchField: 'order_id',
      searchQuery: key,
    })
    const { list } = normalizeOrdersResponse(raw)
    return list.find((o) => orderDisplayIdMatches(o, key)) ?? list[0] ?? null
  } catch {
    return null
  }
}

function careListRouteForPropsSub(): ReturnType<typeof careOrdersListRouteForSub> {
  return careOrdersListRouteForSub(props.careSubKey)
}

function stripOrderDetailQueryFromRoute() {
  const q = { ...route.query } as Record<string, string | string[] | undefined>
  if ('orderDetail' in q) {
    delete q.orderDetail
    void router.replace({ ...careListRouteForPropsSub(), query: q })
    return
  }
  if (isCareOrdersDetailRoute(route)) {
    void router.replace(careListRouteForPropsSub())
  }
}

function openOrderDetail(order: OrderCardDTO) {
  openDd.value = null
  openCal.value = null
  orderDetailNeedsListRefresh.value = false
  void router.push(careOrdersDetailRoute(order.id))
}

async function openOrderDetailById(orderId: string): Promise<boolean> {
  const key = orderId.trim()
  if (!key) return false

  openDd.value = null
  openCal.value = null
  orderDetailNeedsListRefresh.value = false

  let card =
    findOrderCardInLoadedCaches(key) ??
    readOrderDetailFocusFromSession(key) ??
    (await fetchOrderCardByDisplayId(key))

  if (!card) {
    emit('toast', { type: 'warning', message: 'Order not found.' })
    stripOrderDetailQueryFromRoute()
    return false
  }

  orderDetailOverlayOrder.value = card
  return true
}

function closeOrderDetailOverlay(opts?: { skipRouteStrip?: boolean }) {
  orderDetailOverlayOrder.value = null
  if (
    !opts?.skipRouteStrip &&
    (isCareOrdersDetailRoute(route) || route.query.orderDetail)
  ) {
    stripOrderDetailQueryFromRoute()
  }
  if (orderDetailNeedsListRefresh.value) {
    orderDetailNeedsListRefresh.value = false
    void loadOrders()
  }
}

async function syncScheduleOverlayFromRoute() {
  const mode =
    route.name === 'HmCareOrdersSchedule'
      ? 'schedule'
      : route.name === 'HmCareOrdersReschedule'
        ? 'reschedule'
        : null
  if (!mode) return

  const orderId = String(route.params.orderId ?? '').trim()
  if (!orderId) {
    void router.replace(careListRouteForPropsSub())
    return
  }

  const lineIndex = Math.max(0, Number(route.query.lineIndex) || 0)

  if (
    scheduleOverlayOpen.value &&
    scheduleOverlayFocus.value?.orderId === orderId &&
    scheduleOverlayFocus.value?.lineIndex === lineIndex &&
    scheduleOverlayFocus.value?.mode === mode
  ) {
    return
  }

  // 同会话内 openScheduleOverlay 已写入内存焦点：正常打开
  if (
    scheduleOverlayFocus.value &&
    orderDisplayIdMatches({ id: scheduleOverlayFocus.value.orderId } as OrderCardDTO, orderId) &&
    scheduleOverlayFocus.value.mode === mode &&
    scheduleOverlayFocus.value.lineIndex === lineIndex
  ) {
    showScheduleOverlay(scheduleOverlayFocus.value)
    return
  }

  // 刷新或直接访问 schedule URL：不恢复弹框，回到列表
  scheduleOverlayOpen.value = false
  scheduleOverlayFocus.value = null
  clearScheduleSessionStorage()
  void router.replace(careListRouteForPropsSub())
}

watch(
  () =>
    isCareOrdersScheduleOverlayRoute(route)
      ? `${String(route.name)}|${String(route.params.orderId ?? '')}|${String(route.query.lineIndex ?? '0')}`
      : '',
  (key) => {
    if (!key) return
    void syncScheduleOverlayFromRoute()
  },
  { immediate: true },
)

watch(
  () => route.name,
  (name) => {
    if (!isCareOrdersScheduleOverlayRoute({ name }) && scheduleOverlayOpen.value) {
      scheduleOverlayOpen.value = false
      scheduleOverlayFocus.value = null
      clearScheduleSessionStorage()
    }
  },
)

watch(
  () =>
    isCareOrdersRefundRoute(route)
      ? `${String(route.params.orderId ?? '')}|${String(route.query.lineIndex ?? '0')}`
      : '',
  (key) => {
    if (!key) return
    void syncRefundModalFromRoute()
  },
  { immediate: true },
)

watch(
  () => route.name,
  (name) => {
    if (!isCareOrdersRefundRoute({ name }) && refundModalOpen.value && !refundSaving.value) {
      refundModalOpen.value = false
      refundTarget.value = null
    }
  },
)

watch(
  () => isCareOrdersNewRoute(route),
  (onNewRoute) => {
    newOrderModalOpen.value = onNewRoute
  },
  { immediate: true },
)

watch(newOrderModalOpen, (open) => {
  if (!open && isCareOrdersNewRoute(route)) {
    void router.replace(careListRouteForPropsSub())
  }
})

defineExpose({ openOrderDetailById })

function onOrderDetailOrdersRefresh() {
  orderDetailNeedsListRefresh.value = true
}

function onDetailPanelAddNote(order: OrderCardDTO) {
  const lineIndex = order.services.findIndex((line) => !isFollowUpCareLine(line))
  openNoteModal(order, lineIndex >= 0 ? lineIndex : 0)
}

function onDetailPanelSchedule(order: OrderCardDTO) {
  const { line, lineIndex } = scheduleActionTargetForOrder(order)
  void onLineAction(order, line, lineIndex, 'schedule')
}

function onDetailPanelReschedule(order: OrderCardDTO) {
  const { line, lineIndex } = scheduleActionTargetForOrder(order)
  void openScheduleOverlay(order, line, lineIndex, 'reschedule')
}

function onDetailPanelRefund(order: OrderCardDTO) {
  const line = mergedMainLine(order)
  void openRefundModal(order, line, 0)
}

function openNoteModal(order: OrderCardDTO, lineIndex: number) {
  noteTarget.value = { order, lineIndex }
  noteDraft.value = order.notes || ''
  noteModalOpen.value = true
  openDd.value = null
  openCal.value = null
}

async function openRefundModal(order: OrderCardDTO, line: OrderServiceLineDTO, lineIndex: number) {
  refundTarget.value = { order, line, lineIndex }
  openDd.value = null
  openCal.value = null
  const ok = await loadRefundContextForTarget(order, lineIndex)
  if (!ok) {
    refundTarget.value = null
    return
  }
  refundModalOpen.value = true
  if (!isCareOrdersRefundRoute(route) || String(route.params.orderId ?? '').trim() !== order.id) {
    void router.push(careOrdersRefundRoute(order.id, lineIndex))
  }
}

function closeRefundModal() {
  if (refundSaving.value || refundContextLoading.value) return
  refundModalOpen.value = false
  refundTarget.value = null
  resetRefundContextDisplay()
  if (isCareOrdersRefundRoute(route)) {
    void router.replace(careListRouteForPropsSub())
  }
}

function leaveRefundRouteIfNeeded() {
  if (isCareOrdersRefundRoute(route)) {
    void router.replace(careListRouteForPropsSub())
  }
}

async function confirmRefundModal(payload: RefundSubmitPayload) {
  if (refundSaving.value) return
  const t = refundTarget.value
  if (!t) return
  const { order, lineIndex } = t
  const pk = order.orderPrimaryId
  if (pk == null || !Number.isFinite(pk) || pk <= 0) {
    emit('toast', { type: 'error', message: 'Order id missing for refund' })
    return
  }
  const busyKey = lineActionBusyKey(order.id, lineIndex)
  refundSaving.value = true
  lineActionBusy.value = busyKey
  try {
    const response = await postCareOrderRefund({
      id: pk,
      line_index: lineIndex,
      amount: payload.amount,
      tax_type: payload.taxMode,
      note: payload.note,
    })
    if (response.code !== 200) {
      emit('toast', { type: 'error', message: response.msg || 'Refund failed' })
      return
    }
    refundModalOpen.value = false
    refundTarget.value = null
    resetRefundContextDisplay()
    leaveRefundRouteIfNeeded()
    emit('toast', { type: 'success', message: lineActionSuccessMessage('refund') })
    const refreshed = await refreshOrderInListFromDetail(order)
    if (!refreshed) await loadOrders()
  } catch (e: unknown) {
    emit('toast', { type: 'error', message: apiErrorMessage(e) })
  } finally {
    refundSaving.value = false
    if (lineActionBusy.value === busyKey) lineActionBusy.value = null
  }
}

async function syncRefundModalFromRoute() {
  if (!isCareOrdersRefundRoute(route)) return

  const orderId = String(route.params.orderId ?? '').trim()
  if (!orderId) {
    void router.replace(careListRouteForPropsSub())
    return
  }

  const lineIndex = Math.max(0, Number(route.query.lineIndex) || 0)

  if (
    refundModalOpen.value &&
    refundTarget.value &&
    orderDisplayIdMatches(refundTarget.value.order, orderId) &&
    refundTarget.value.lineIndex === lineIndex
  ) {
    return
  }

  if (
    refundTarget.value &&
    orderDisplayIdMatches(refundTarget.value.order, orderId) &&
    refundTarget.value.lineIndex === lineIndex
  ) {
    const ok = await loadRefundContextForTarget(refundTarget.value.order, lineIndex)
    if (!ok) {
      refundTarget.value = null
      void router.replace(careListRouteForPropsSub())
      return
    }
    refundModalOpen.value = true
    return
  }

  let order = findOrderCardInLoadedCaches(orderId)
  if (!order) {
    order = await fetchOrderCardByDisplayId(orderId)
  }
  if (!order) {
    refundModalOpen.value = false
    refundTarget.value = null
    resetRefundContextDisplay()
    void router.replace(careListRouteForPropsSub())
    return
  }

  const line = order.services[lineIndex] ?? order.services[0]
  if (!line) {
    refundModalOpen.value = false
    refundTarget.value = null
    resetRefundContextDisplay()
    void router.replace(careListRouteForPropsSub())
    return
  }

  refundTarget.value = { order, line, lineIndex }
  const ok = await loadRefundContextForTarget(order, lineIndex)
  if (!ok) {
    refundTarget.value = null
    resetRefundContextDisplay()
    void router.replace(careListRouteForPropsSub())
    return
  }
  refundModalOpen.value = true
  openDd.value = null
  openCal.value = null
}

function closeNoteModal() {
  if (noteSaving.value) return
  noteModalOpen.value = false
  noteTarget.value = null
}

async function confirmNoteModal() {
  if (noteSaving.value) return
  const t = noteTarget.value
  if (!t) return
  const trimmed = noteDraft.value.trim()
  if (!trimmed) {
    emit('toast', { type: 'warning', message: 'Please enter note text.' })
    return
  }
  const notesLimitErr = validateStringLength(trimmed, orderFieldLimits.notes, 'Notes')
  if (notesLimitErr) {
    emit('toast', { type: 'warning', message: notesLimitErr })
    return
  }
  const { order, lineIndex } = t
  const target = await resolveCareOrderUpdateNotesTarget(order, lineIndex, postCareOrderDetail)
  if (!target) {
    emit('toast', { type: 'error', message: 'Cannot save notes: order id is missing.' })
    return
  }

  noteSaving.value = true
  patchOrderNotes(order.id, trimmed)

  const busyKey = lineActionBusyKey(order.id, lineIndex)
  lineActionBusy.value = busyKey
  try {
    await postCareOrderUpdateNotes({
      target_type: target.target_type,
      target_id: target.target_id,
      notes: trimmed,
    })
    await refreshOrderInListFromDetail(order, { preserveNotes: trimmed })
    noteModalOpen.value = false
    noteTarget.value = null
    emit('toast', { type: 'success', message: lineActionSuccessMessage('note') })
  } catch (e: unknown) {
    emit('toast', {
      type: 'warning',
      message: `${apiErrorMessage(e)} Your note is shown on the card only until the server accepts it.`,
    })
  } finally {
    noteSaving.value = false
    if (lineActionBusy.value === busyKey) lineActionBusy.value = null
  }
}

function resolveOrderDeletePrimaryId(order: OrderCardDTO): number | null {
  const pk = order.orderPrimaryId
  if (pk != null && pk > 0) return Math.trunc(pk)
  const raw = (order.id ?? '').trim()
  if (!raw || raw === '—') return null
  const hm = raw.match(/^HM-(\d+)$/i)
  if (hm?.[1]) {
    const n = parseInt(hm[1], 10)
    return Number.isFinite(n) ? n : null
  }
  if (/^\d+$/.test(raw)) {
    const n = parseInt(raw, 10)
    return Number.isFinite(n) ? n : null
  }
  return null
}

function openOrderDeleteModal(order: OrderCardDTO) {
  if (resolveOrderDeletePrimaryId(order) == null) {
    emit('toast', { type: 'error', message: 'Cannot delete: order id is missing.' })
    return
  }
  orderDeleteTarget.value = order
  orderDeleteModalOpen.value = true
}

function closeOrderDeleteModal() {
  if (orderDeleteSubmitting.value) return
  orderDeleteModalOpen.value = false
  orderDeleteTarget.value = null
}

async function confirmOrderDelete() {
  const order = orderDeleteTarget.value
  if (!order || orderDeleteSubmitting.value) return
  const pk = resolveOrderDeletePrimaryId(order)
  if (pk == null) {
    emit('toast', { type: 'error', message: 'Cannot delete: order id is missing.' })
    return
  }
  orderDeleteSubmitting.value = true
  try {
    await postCareOrderDelete(pk)
    if (
      orderDetailOverlayOrder.value &&
      orderDisplayIdMatches(orderDetailOverlayOrder.value, order.id)
    ) {
      closeOrderDetailOverlay()
    }
    orderDeleteModalOpen.value = false
    orderDeleteTarget.value = null
    emit('toast', { type: 'success', message: 'Successfully deleted' })
    invalidateCareOrderListCache()
    if (scheduleOverlayOpen.value) {
      scheduleExternalRefreshNonce.value += 1
    }
    await loadOrders()
    refreshSidebarBadgesNow()
  } catch (e: unknown) {
    emit('toast', { type: 'error', message: apiErrorMessage(e) })
  } finally {
    orderDeleteSubmitting.value = false
  }
}

async function onLineAction(
  order: OrderCardDTO,
  line: OrderServiceLineDTO,
  lineIndex: number,
  action: 'schedule' | 'refund' | 'message' | 'note',
) {
  if (action === 'message') return

  if (action === 'refund') {
    openRefundModal(order, line, lineIndex)
    return
  }

  const allowed =
    (action === 'schedule' &&
      (line.canSchedule ||
        line.canReschedule ||
        (isFollowUpCareLine(line) &&
          resolveOrderCardHeadServiceStatus(order) === CARE_SERVICE_STATUS_FU_PENDING_SCHEDULE) ||
        (!isFollowUpCareLine(line) &&
          resolveOrderCardHeadServiceStatus(order) === CARE_SERVICE_STATUS_PENDING_SCHEDULE))) ||
    (action === 'note' && lineAllowsNoteAction(order, line, lineIndex))
  if (!allowed) return

  if (action === 'note') {
    openNoteModal(order, lineIndex)
    return
  }

  if (
    action === 'schedule' &&
    orderIsMainPendingRescheduleOrder(order) &&
    !orderStatusIsCompleted(order.status)
  ) {
    void openScheduleOverlay(order, line, lineIndex, 'reschedule')
    return
  }

  const fuPendingSchedule =
    isFollowUpCareLine(line) &&
    resolveOrderCardHeadServiceStatus(order) === CARE_SERVICE_STATUS_FU_PENDING_SCHEDULE &&
    !lineHasConfirmedScheduleTime(line, order)
  const mainPendingSchedule =
    !isFollowUpCareLine(line) &&
    resolveOrderCardHeadServiceStatus(order) === CARE_SERVICE_STATUS_PENDING_SCHEDULE &&
    !lineHasConfirmedScheduleTime(line, order)

  const mainPendingScheduleOrder = orderCardIsMainPendingSchedule(order)
  const fuPendingScheduleOrder =
    isFollowUpCareLine(line) && orderCardIsFuPendingSchedule(order)

  if (
    action === 'schedule' &&
    (line.canReschedule || lineHasConfirmedScheduleTime(line, order)) &&
    !orderStatusIsCompleted(order.status) &&
    !mainPendingScheduleOrder &&
    !fuPendingScheduleOrder
  ) {
    void openScheduleOverlay(order, line, lineIndex, 'reschedule')
    return
  }

  if (action === 'schedule' && (line.canSchedule || fuPendingSchedule || mainPendingSchedule) && isOrderEligibleForSchedule(order)) {
    void openScheduleOverlay(order, line, lineIndex, 'schedule')
    return
  }

  let body: Record<string, unknown> | undefined
  const busyKey = lineActionBusyKey(order.id, lineIndex)
  lineActionBusy.value = busyKey
  try {
    await postCareOrderLineAction(order.id, lineIndex, action, body)
    emit('toast', { type: 'success', message: lineActionSuccessMessage(action) })
    const refreshed = await refreshOrderInListFromDetail(order)
    if (!refreshed) await loadOrders()
  } catch (e: unknown) {
    emit('toast', { type: 'error', message: apiErrorMessage(e) })
  } finally {
    if (lineActionBusy.value === busyKey) lineActionBusy.value = null
  }
}

function onDocClick(e: MouseEvent) {
  const target = e.target as Node
  const host = rootRef.value
  if (!host) return

  const inDropdown = Array.from(host.querySelectorAll('.has-dropdown')).some((el) =>
    el.contains(target),
  )
  if (!inDropdown) openDd.value = null

  const inDate = Array.from(host.querySelectorAll('.date-wrapper')).some((el) =>
    el.contains(target),
  )
  if (!inDate) openCal.value = null
}

onMounted(() => {
  document.addEventListener('click', onDocClick)
  applyCareSubKey(props.careSubKey)
  void (async () => {
    await loadCareMeta()
    tryConsumeCareOrdersListPrefill()
    await loadOrders()
  })()
})

onUnmounted(() => {
  document.removeEventListener('click', onDocClick)
  refreshSidebarBadgesNow()
})
</script>

<style scoped>
.hm-care-orders {
  /* 设计稿 .page / group_1 / box_55–57 / group_10（1440 画布） */
  --page-title-bar-h: calc(24px + 26px + 16px);
  --care-content-pad-x: 24px;
  /* 右侧交给 IndexPage home-root--gutter-scroll（12px + gutter ≈ 24px） */
  --care-content-pad-right: 0;
  --care-page-bg: #f5f6fb;
  /* 内容区随主区域伸缩；左右由 .order-page 固定 24px 内边距 */
  --care-content-w: 100%;
  --care-box57-w: 100%;
  --care-box57-inset-l: 8px;
  --care-box57-inset-r: 0px;
  --care-row-inner-w: calc(100% - 32px);
  --care-row-gap: 16px;
  /* 设计稿单格 273px（1140 内容宽 = 4×273 + 3×16）；栅格四列等分，缩放时五格始终同宽 */
  --care-filter-field-target: 273px;
  --care-filter-grid-cols: repeat(4, minmax(0, 1fr));
  --care-field-w: 100%;
  --care-stack-gap: 12px;
  --care-filter-field-h: 32px;
  --care-filter-field-bg: #ffffff;
  --care-filter-field-border: #e0e0e0;
  --care-filter-field-radius: 16px;
  --care-filter-group-w: 100%;
  --care-filter-group-h: 112px;
  --care-filter-group-bg: #ffffff;
  --care-filter-group-border: #e0e0e0;
  --care-filter-group-radius: 16px;
  --care-order-card-w: 100%;
  --care-card-head-h: 32px;
  --care-card-body-h: 136px;
  --care-card-body-merged-h: 245px;
  --care-order-notes-h: 32px;
  --care-order-notes-bg: #fef39c;
  --care-order-notes-border: #e0e0e0;
  --care-order-notes-radius: 0 0 16px 16px;
  --care-order-card-h: calc(var(--care-card-head-h) + var(--care-card-body-h));
  --care-order-card-h-merged: calc(var(--care-card-head-h) + var(--care-card-body-merged-h));
  --care-order-card-h-with-notes: calc(
    var(--care-card-head-h) + var(--care-card-body-h) + var(--care-order-notes-h)
  );
  --care-order-card-h-merged-with-notes: calc(
    var(--care-card-head-h) + var(--care-card-body-merged-h) + var(--care-order-notes-h)
  );
  --care-card-body-pad-bottom: 16px;
  --care-svc-text-row-gap: 8px;
  --care-svc-tags-offset-top: calc(
    var(--care-svc-name-offset-top) + var(--care-svc-time-line-h) + var(--care-svc-text-row-gap)
  );
  --care-svc-tags-line-h: 20px;
  --care-svc-time-line-h: 20px;
  --care-svc-time-pending-color: #999999;
  /* 彩色字 → 时间 → 地址：行高 20px，行间 8px */
  --care-svc-time-offset-top: calc(
    var(--care-svc-tags-offset-top) + var(--care-svc-tags-line-h) + var(--care-svc-text-row-gap)
  );
  --care-svc-time-offset-bottom: 44px;
  --care-svc-addr-offset-top: calc(
    var(--care-svc-time-offset-top) + var(--care-svc-time-line-h) + var(--care-svc-text-row-gap)
  );
  --care-svc-addr-offset-bottom: 16px;
  --care-svc-name-offset-top: 16px;
  --care-svc-icon-offset-top: 16px;
  --care-svc-icon-offset-left: 16px;
  --care-svc-icon-offset-bottom: 72px;
  --care-svc-icon-size: 48px;
  --care-svc-icon-gap: 16px;
  --care-svc-text-col-left: calc(
    var(--care-svc-icon-offset-left) + var(--care-svc-icon-size) + var(--care-svc-icon-gap)
  );
  /* 有左 padding 时，流式小标题与绝对定位彩色字/时间/地址共用左缘 */
  --care-svc-text-col-inset: calc(var(--care-svc-text-col-left) - var(--care-svc-icon-offset-left));
  /* 跟进合并单 · 主单地址（顶 = 时间 + 8px 行距，勿改间距链） */
  --care-merged-main-addr-offset-top: var(--care-svc-addr-offset-top);
  /* 主单地址底 → 分割线：16px；分割线 → 跟进行内容顶：16px */
  --care-merged-divider-gap: 16px;
  --care-merged-divider-offset-top: calc(
    var(--care-merged-main-addr-offset-top) + var(--care-svc-time-line-h) + var(--care-merged-divider-gap)
  );
  --care-merged-fu-section-offset-top: calc(
    var(--care-merged-divider-offset-top) + 1px + var(--care-merged-divider-gap)
  );
  /* 跟进合并单 · 跟进行地址（设计稿固定：距灰顶栏底 209px、左 80，勿改） */
  --care-merged-fu-addr-offset-top: 209px;
  /* 跟进合并单 · 跟进行：标题位置不变，Pending Schedule → 地址 依次 8px（流式布局，见 merged-svc--1） */
  --care-merged-fu-time-offset-top: calc(
    var(--care-merged-fu-section-offset-top)
    + var(--care-merged-divider-gap)
    + var(--care-svc-time-line-h)
    + var(--care-svc-text-row-gap)
  );
  /* 跟进合并单 · 跟进行 Pending Assignment / 服务人员姓名：距白色 card-body 顶 171px */
  --care-merged-fu-assign-name-offset-top: 171px;
  --care-merged-fu-assign-padding-top: calc(
    var(--care-merged-fu-assign-name-offset-top) - var(--care-merged-divider-offset-top) - 1px
  );
  /* 跟进合并单 · 主单彩色字（设计稿固定：顶 44、左 80，勿改） */
  --care-merged-main-tags-offset-top: 44px;
  /* 跟进合并单 · 主单服务人员姓名顶（设计稿：与白框顶 44px，与彩色字同一水平线） */
  --care-merged-main-assign-offset-top: 44px;
  --care-svc-tags-offset-bottom: 72px;
  --care-box56-search-offset: 691px;
  width: 100%;
  /* 标题随页面滚动；正文区由 .order-page 控左 24 / 右 0（右距由 gutter-scroll 承担） */
  padding: 0 0 var(--care-content-pad-x);
  box-sizing: border-box;
  overflow: visible;
  background: var(--care-page-bg);
}

.page-title-bar {
  background: var(--care-page-bg);
  box-sizing: border-box;
  margin: 0;
  padding: 24px var(--care-content-pad-right) 16px var(--care-content-pad-x);
}

.order-page {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0 var(--care-content-pad-right) 0 var(--care-content-pad-x);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.orders-page-head {
  background: var(--care-page-bg);
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 100%;
}

.page-title {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: 0;
  color: #000000;
  text-align: left;
}

.order-top-bar {
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  background: transparent;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
  border-radius: 0;
  box-shadow: none;
}

/* group_1：1172×112，圆角 16；内行用 margin 定位（与导出一致，不用 padding+gap） */
.filter-wrapper,
.filter-group_1 {
  box-sizing: border-box;
  width: var(--care-filter-group-w);
  max-width: 100%;
  height: auto;
  min-height: var(--care-filter-group-h);
  margin: 0;
  padding: 0;
  background: var(--care-filter-group-bg);
  border: 1px solid var(--care-filter-group-border);
  border-radius: var(--care-filter-group-radius);
  display: block;
  overflow: visible;
}

/* box_55：1140×32，margin 16px 0 0 16px */
.filter-row-primary,
.filter-box_55 {
  box-sizing: border-box;
  width: var(--care-row-inner-w);
  max-width: 100%;
  min-height: var(--care-filter-field-h);
  height: auto;
  margin: 16px 0 0 16px;
  padding: 0;
  position: relative;
}

.filter-row-primary-inputs {
  display: grid;
  grid-template-columns: var(--care-filter-grid-cols);
  column-gap: var(--care-row-gap);
  row-gap: var(--care-row-gap);
  align-items: center;
  width: 100%;
  min-height: var(--care-filter-field-h);
  min-width: 0;
}

.filter-row-primary-inputs > .filter-item,
.filter-row-primary-inputs > .date-wrapper {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.filter-row-primary-inputs > .date-wrapper .date-item-box {
  width: 100%;
  max-width: 100%;
}

.filter-row-primary-inputs--fu {
  grid-template-columns: var(--care-filter-grid-cols);
}

/* box_56：1140×32，margin 16px 0 16px 16px；Search 区 margin-left 691px */
.filter-row-bottom,
.filter-box_56 {
  box-sizing: border-box;
  display: grid;
  grid-template-columns: var(--care-filter-grid-cols);
  column-gap: var(--care-row-gap);
  row-gap: var(--care-row-gap);
  align-items: center;
  width: var(--care-row-inner-w);
  max-width: 100%;
  min-height: var(--care-filter-field-h);
  height: auto;
  margin: 16px 16px 16px 16px;
  padding: 0;
  position: relative;
}

.filter-box_56 > .tech-item,
.filter-box_56 > .insp-item {
  box-sizing: border-box;
  grid-column: 1;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.filter-box_56--fu > .insp-item {
  grid-column: 1;
}

.filter-box_56--fu > .tech-item {
  grid-column: 2;
  margin-left: 0;
}

.filter-box_56 > .btn-group {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: var(--care-row-gap);
  grid-column: 4;
  justify-self: end;
  margin-left: 0;
}

.date-item-box .fu-pr-status-static-value {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filter-row-primary-inputs--fu .fu-fs-status-select {
  min-width: 0;
}

.select-item.fu-fs-status-select input {
  color: #666666;
  -webkit-text-fill-color: #666666;
  font-weight: 500;
  cursor: pointer;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
}

.filter-box_55.filter-row {
  display: block;
}

.filter-box_56.filter-row {
  display: grid;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 6px;
  position: relative;
}

.has-dropdown {
  position: relative;
}

.filter-item .label {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  white-space: nowrap;
}

.filter-item input {
  border: none;
  outline: none;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
  padding: 0;
  width: 120px;
  background: transparent;
}

.filter-wrapper input::placeholder {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #cccccc;
  opacity: 1;
}

.filter-wrapper input::-webkit-input-placeholder {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #cccccc;
  opacity: 1;
}

.field-type-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  padding: 0;
  flex-shrink: 0;
}

.field-type-btn:focus-visible {
  outline: 2px solid #000000;
  outline-offset: 2px;
  border-radius: 4px;
}

.filter-wrapper .icon,
.filter-wrapper .downarrow-inline,
.filter-wrapper .downarrow,
.filter-wrapper .calendar-icon-inline {
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}

.field-split {
  width: 1px;
  height: 18px;
  background: #e0e0e0;
  margin: 0 8px 0 2px;
  flex-shrink: 0;
}

.filter-item.order-id-item .field-type-btn {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  -webkit-text-fill-color: #000000;
  flex: 0 1 auto;
  min-width: 0;
  max-width: 58%;
}

/* 与 .date-item-box .label 一致；子级用 inherit 盖过 base.css 里 * { font-weight: normal } */
.filter-item.order-id-item .field-type-btn > .label {
  flex: 0 1 auto;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 4px;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  -webkit-text-fill-color: #000000;
}

.filter-item.order-id-item input {
  flex: 1 1 0;
  min-width: 3.5rem;
  width: 0;
  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 20px;
  letter-spacing: 0;
  color: #333333;
  -webkit-text-fill-color: #333333;
}

.filter-item.order-id-item input::placeholder {
  -webkit-text-fill-color: #cccccc;
}

.order-id-item {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0;
  width: 100%;
  min-width: 0;
  height: var(--care-filter-field-h);
  background: var(--care-filter-field-bg);
  border-radius: var(--care-filter-field-radius);
  border: 1px solid var(--care-filter-field-border);
  padding: 0 16px;
  color: #000000;
  transition: border-color 0.15s ease;
}

.order-id-item:focus-within {
  border-color: #666666;
}

.order-id-item > .field-split {
  flex-shrink: 0;
  margin: 0 8px;
}

.date-wrapper {
  gap: 0;
  width: 100%;
  min-width: 0;
}

.date-calendar-anchor {
  position: relative;
  width: 100%;
  min-width: 0;
}

.date-item-box {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: var(--care-filter-field-h);
  background: var(--care-filter-field-bg);
  border-radius: var(--care-filter-field-radius);
  border: 1px solid var(--care-filter-field-border);
  display: flex;
  align-items: center;
  padding: 0 16px;
  transition: border-color 0.15s ease;
}

.date-item-box:focus-within {
  border-color: #666666;
}

.date-item-box .label {
  flex-shrink: 0;
  white-space: nowrap;
  margin-right: 6px;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
}

.date-item-box input {
  flex: 1;
  min-width: 0;
  width: auto;
  padding: 0;
  padding-right: 4px;
  cursor: pointer;
}

.date-cal-split {
  width: 1px;
  height: 16px;
  background: #d8d8d8;
  flex-shrink: 0;
}

.calendar-icon-inline {
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-left: 4px;
  cursor: pointer;
  display: block;
  object-fit: contain;
  flex-shrink: 0;
}

.select-item {
  box-sizing: border-box;
  width: 100%;
  height: var(--care-filter-field-h);
  background: var(--care-filter-field-bg);
  border-radius: var(--care-filter-field-radius);
  border: 1px solid var(--care-filter-field-border);
  padding: 0 16px;
  transition: border-color 0.15s ease;
}

.select-item:focus-within {
  border-color: #666666;
}

.filter-row-primary-inputs .select-item {
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.filter-box_56 .select-item {
  width: 100%;
  min-width: 0;
  max-width: none;
}

.select-item input {
  flex: 1;
  min-width: 0;
  width: auto;
  padding-right: 28px;
  cursor: pointer;
}

/* Service Status / Technician 等为 All 时的占位展示（只读 input 无 ::placeholder） */
.select-item input.filter-select-placeholder {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #cccccc;
  -webkit-text-fill-color: #cccccc;
}

.tech-item {
  margin-top: 0;
}

.insp-item {
  margin-top: 0;
}

.icon {
  object-fit: contain;
  cursor: pointer;
}

.downarrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.dropdown-panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  max-height: 280px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 20;
  list-style: none;
  margin: 0;
  padding: 6px 0;
}

.dropdown-panel li {
  padding: 8px 12px;
  font-size: 14px;
  cursor: pointer;
  color: #333;
}

.dropdown-panel li:hover,
.dropdown-panel li.active {
  background: #f2f2f2;
}

/* Order ID 字段下拉：SF Pro Regular 14/16 #000，可滚动无滚动条 */
.order-id-item .dropdown-panel {
  max-height: 280px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.order-id-item .dropdown-panel::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.order-id-item .dropdown-panel li {
  padding: 8px 12px;
  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Display', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 16px;
  letter-spacing: 0;
  color: #000000;
  text-align: left;
}

.order-id-item .dropdown-panel li:hover {
  background: #f5f5f5;
}

.order-id-item .dropdown-panel li.active {
  font-weight: 600;
  color: #000000;
  background: transparent;
}

.order-id-item .dropdown-panel li.active:hover {
  background: #f5f5f5;
}

.calendar-pop {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 25;
}

.search-btn {
  box-sizing: border-box;
  width: 80px;
  height: 32px;
  padding: 4px 16px 4px 15px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  background: #000000;
  color: #ffffff;
  border: none;
  border-radius: 16px;
  font-family: SFPro, SFPro, -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0;
  cursor: pointer;
}

.search-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-btn:hover:not(:disabled) {
  background: #484848;
}

.clear-btn {
  box-sizing: border-box;
  width: 80px;
  height: 32px;
  padding: 4px 22px 4px 21px;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  background: #B0B0B0;
  color: #FFFFFF;
  border: none;
  border-radius: 16px;
  font-family: SFPro, SFPro, -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  line-height: 24px;
  text-align: right;
  cursor: pointer;
}
.clear-btn:hover {
  background: #CCCCCC;
}
/* box_57：1164×32，margin 12px 0 0 8px；右缘与筛选白框、页面内容区同为 24px（含滚动条） */
.order-meta-row,
.order-stats-box_57 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  width: calc(100% - var(--care-box57-inset-l) - var(--care-box57-inset-r));
  max-width: calc(var(--care-box57-w) - var(--care-box57-inset-l) - var(--care-box57-inset-r));
  height: var(--care-filter-field-h);
  min-height: var(--care-filter-field-h);
  margin: var(--care-stack-gap) var(--care-box57-inset-r) 0 var(--care-box57-inset-l);
  padding: 0;
  gap: 0;
}

.new-btn {
  box-sizing: border-box;
  width: 80px;
  height: 32px;
  padding: 0;
  background: #00aeef;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 16px;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.new-btn:hover {
  background: #2a5d8f;
}

.order-count {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0;
  color: #000000;
  text-align: left;
  min-height: 24px;
  margin-top: 4px;
  flex-shrink: 0;
}

.order-count--pending {
  visibility: hidden;
}

.orders-body {
  overflow: visible;
  padding: 0;
  margin-top: var(--care-stack-gap);
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

.orders-list {
  margin-top: 0;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  /* 设计稿 group_12 等块间距 16px */
  gap: 16px;
  position: relative;
}

.order-card > .group_10,
.order-card > .card-head {
  flex-shrink: 0;
  position: relative;
  z-index: 10;
}

.orders-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px 32px;
  box-sizing: border-box;
}

.orders-empty-img {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
}

.orders-empty-msg {
  margin: 12px 0 0;
  font-size: 24px;
  font-weight: 500;
  color: #b0b0b0;
}

.order-card {
  box-sizing: border-box;
  width: var(--care-order-card-w);
  max-width: 100%;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  overflow: hidden;
  padding-bottom: 0;
  box-shadow: none;
  isolation: isolate;
}

/* 单行订单、无备注：1172×168（设计稿 group_12）；地址过长时卡片随内容增高 */
.order-card:not(.order-card--has-notes):not(:has(.card-body--merged-split)):not(:has(.card-body + .card-body)) {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: var(--care-order-card-h);
}

.order-card:not(.order-card--has-notes):not(:has(.card-body--merged-split)):not(:has(.card-body + .card-body)) > .card-body {
  flex: 0 0 auto;
  min-height: var(--care-card-body-h);
  height: auto;
  box-sizing: border-box;
}

.order-card:not(.order-card--has-notes):has(.card-body--merged-split) {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: var(--care-order-card-h-merged);
}

.order-card:not(.order-card--has-notes):has(.card-body--merged-split) > .card-body--merged-split {
  flex: 0 0 auto;
  min-height: var(--care-card-body-merged-h);
  height: auto;
  box-sizing: border-box;
}

.order-card:not(.order-card--has-notes):has(.card-body + .card-body):not(:has(.card-body--merged-split)) {
  min-height: var(--care-order-card-h);
}

/* 单行订单 + 备注：1172×200（设计稿 group_12 + notes）；地址过长时卡片随内容增高 */
.order-card--has-notes:not(:has(.card-body--merged-split)):not(:has(.card-body + .card-body)) {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: var(--care-order-card-h-with-notes);
}

.order-card--has-notes:not(:has(.card-body--merged-split)):not(:has(.card-body + .card-body)) > .card-body {
  flex: 0 0 auto;
  min-height: var(--care-card-body-h);
  height: auto;
  box-sizing: border-box;
}

.order-card--has-notes:not(:has(.card-body--merged-split)):not(:has(.card-body + .card-body)) > .notes-banner {
  flex: 0 0 auto;
  height: auto;
  min-height: var(--care-order-notes-h);
  box-sizing: border-box;
}

.order-card--has-notes:has(.card-body--merged-split) {
  display: flex;
  flex-direction: column;
  height: auto;
  min-height: var(--care-order-card-h-merged-with-notes);
}

.order-card--has-notes:has(.card-body--merged-split) > .card-body--merged-split {
  flex: 0 0 auto;
  min-height: var(--care-card-body-merged-h);
  height: auto;
  box-sizing: border-box;
}

.order-card--has-notes:has(.card-body + .card-body):not(:has(.card-body--merged-split)) {
  min-height: var(--care-order-card-h-with-notes);
}

.card-head,
.group_10 {
  display: grid;
  grid-template-columns: max-content max-content minmax(0, 1fr) max-content;
  gap: 0;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  height: var(--care-card-head-h);
  min-height: var(--care-card-head-h);
  align-items: center;
  background: #f7f7f7;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 16px 16px 0 0;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  overflow-x: auto;
  overflow-y: hidden;
}

.head-cell.head-cell-id,
.head-cell.head-cell-home {
  overflow: visible;
  min-width: max-content;
}

.head-cell.head-cell-id .head-label,
.head-cell.head-cell-id .head-value,
.head-cell.head-cell-home .head-label,
.head-cell.head-cell-home .head-value {
  white-space: nowrap;
}

.head-cell {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 4px 6px;
  padding: 0 12px;
  border-right: 1px solid #e0e0e0;
  box-sizing: border-box;
  min-height: 0;
  overflow: hidden;
}

.head-cell:last-child {
  border-right: none;
}

.head-cell-date {
  justify-content: flex-end;
  text-align: right;
}

.head-cell.head-cell-status {
  border-right: none;
  white-space: nowrap;
  overflow: visible;
}

.head-cell.head-cell-date {
  white-space: nowrap;
  overflow: visible;
}

.head-cell-status .head-label,
.head-cell-status .head-value,
.head-cell-date .head-label,
.head-cell-date .head-value {
  white-space: nowrap;
}

.head-label {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #999999;
  text-align: left;
}

.head-value {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  text-align: left;
}

.order-card > .notes-banner {
  position: relative;
  z-index: 10;
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-radius: 0;
}

.notes-banner {
  box-sizing: border-box;
  width: var(--care-order-card-w);
  max-width: 100%;
  height: auto;
  min-height: var(--care-order-notes-h);
  padding: 6px 14px;
  background: var(--care-order-notes-bg);
  border: 1px solid var(--care-order-notes-border);
  border-radius: var(--care-order-notes-radius);
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #484848;
  text-align: left;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

.order-card > .card-body:last-child:not(.card-body--merged-split) {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.order-card:not(.order-card--has-notes) > .card-body--merged-split:last-child {
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.order-card--has-notes > .card-body--merged-split {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.order-card > .card-body--merged-split {
  border-left: none;
  border-right: none;
  border-bottom: none;
  border-radius: 0;
}

.card-body {
  display: grid;
  grid-template-columns: 2.4fr 1fr 0.75fr minmax(min-content, 0.58fr) 0.87fr;
  gap: 0;
  padding: 0 18px 0 var(--care-svc-icon-offset-left);
  align-items: stretch;
  font-size: 13px;
  margin: -1px 0 0;
  background: #ffffff;
  border: none;
  border-radius: 0;
  box-shadow: none;
  position: relative;
  z-index: 0;
  min-height: var(--care-card-body-h);
  box-sizing: border-box;
}

.card-body:not(.card-body--merged-split) {
  padding-bottom: 0;
}

/* 地址行距白色 card-body 底 16px（仅服务列，不影响右侧操作列） */
.card-body:not(.card-body--merged-split) .col-service {
  padding-bottom: var(--care-svc-addr-offset-bottom);
  box-sizing: border-box;
}

.card-body + .card-body {
  border-top: 1px solid #e0e0e0;
}

.card-body--merged-split {
  display: grid;
  grid-template-columns: 2.4fr 1fr 0.75fr minmax(min-content, 0.58fr) 0.87fr;
  grid-template-rows: auto minmax(0, 1fr);
  gap: 0;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: var(--care-card-body-merged-h);
  padding: 0 18px 0 var(--care-svc-icon-offset-left);
  align-items: stretch;
  font-size: 13px;
  margin: -1px 0 0;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-top: none;
  border-radius: 0 0 16px 16px;
  box-shadow: none;
  position: relative;
  z-index: 0;
}

.order-card--has-notes .card-body--merged-split {
  border-radius: 0;
  border-bottom: none;
}

.card-body--merged-split .merged-svc--0 {
  grid-column: 1;
  grid-row: 1;
  position: static;
  min-height: var(--care-merged-divider-offset-top);
}

.card-body--merged-split .merged-svc--0.col-service {
  position: static;
}

.card-body--merged-split .merged-svc--0 .svc-stack {
  position: static;
  padding-bottom: var(--care-merged-divider-gap);
  gap: var(--care-svc-text-row-gap);
}

/* 主单图标：距白色 card-body 顶 16px、左 16px（设计稿固定，勿改） */
.card-body--merged-split .merged-svc--0 .svc-icon-wrap,
.card-body--merged-split .merged-svc--0 .svc-icon-spacer {
  position: absolute;
  left: var(--care-svc-icon-offset-left);
  top: var(--care-svc-icon-offset-top);
  width: var(--care-svc-icon-size);
  height: var(--care-svc-icon-size);
  z-index: 2;
}

/* 主单检验码 / 时间 / 地址：标题位置不变，下方各行依次 8px（流式布局） */
.card-body--merged-split .merged-svc--0 .svc-tags,
.card-body--merged-split .merged-svc--0 .svc-code,
.card-body--merged-split .merged-svc--0 .svc-time-stack {
  position: static;
  left: auto;
  right: auto;
  top: auto;
  height: auto;
  margin-top: 0;
  z-index: 2;
}

.card-body--merged-split .merged-svc--0 .svc-tags,
.card-body--merged-split .merged-svc--0 .svc-code {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0 3px;
  overflow: hidden;
}

/* 主单地址：距下分割线 16px（设计稿固定，勿改） */
.card-body--merged-split .merged-svc--0 .svc-addr {
  position: static;
  left: auto;
  right: auto;
  top: auto;
  margin-top: 0;
  min-height: var(--care-svc-time-line-h);
  height: auto;
  z-index: 2;
}

.card-body--merged-split .merged-svc--1 {
  grid-column: 1;
  grid-row: 2;
  border-top: none;
  padding-top: var(--care-merged-divider-gap);
  position: relative;
  box-sizing: border-box;
  min-height: calc(
    var(--care-card-body-merged-h) - var(--care-merged-fu-section-offset-top)
  );
}

.card-body--merged-split .merged-svc--1.col-service {
  overflow: visible;
}

.card-body--merged-split .merged-svc--1::before {
  content: '';
  position: absolute;
  top: 0;
  left: calc(-1 * var(--care-svc-icon-offset-left));
  right: 0;
  border-top: 1px solid #e0e0e0;
  pointer-events: none;
}

.card-body--merged-split .merged-assign-bottom {
  grid-column: 2;
  grid-row: 2;
  border-top: 1px solid #e0e0e0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
}

.card-body--merged-split .merged-assign-bottom .assign-name--fu-merge {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  line-height: var(--care-svc-time-line-h);
  margin: 0;
}

.card-body--merged-split .merged-assign-bottom .assign-pending--fu-merge {
  margin: 0;
}

.card-body--merged-split .merged-svc--1 .svc-time-stack {
  position: static;
  left: auto;
  right: auto;
  top: auto;
  height: auto;
  margin-top: 0;
  z-index: 2;
}

.card-body--merged-split .merged-svc--1 .svc-addr {
  position: static;
  left: auto;
  right: auto;
  top: auto;
  margin-top: 0;
  min-height: var(--care-svc-time-line-h);
  height: auto;
  z-index: 2;
}

.card-body--merged-split .merged-svc--1 .svc-stack {
  position: static;
  padding-bottom: var(--care-svc-addr-offset-bottom);
  gap: var(--care-svc-text-row-gap);
}

/* 跟进行标题：距上方分割线 16px（由 merged-svc--1 padding-top 控制，勿叠加 svc-name margin） */
.card-body--merged-split .merged-svc--1 .svc-name {
  margin-top: 0;
}

.card-body--merged-split .merged-assign-top {
  grid-column: 2;
  grid-row: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  padding-bottom: 0;
}

.card-body--merged-split .merged-assign-top .assign-name,
.card-body--merged-split .merged-assign-top .assign-ref,
.card-body--merged-split .merged-assign-top .assign-ref-tip-host,
.card-body--merged-split .merged-assign-top .assign-pending {
  margin-left: 0;
  margin-right: 0;
}

.card-body--merged-split .merged-pay {
  grid-column: 3;
  grid-row: 1 / span 2;
}

.card-body--merged-split .merged-detail {
  grid-column: 4;
  grid-row: 1 / span 2;
}

.card-body--merged-split .merged-actions {
  grid-column: 5;
  grid-row: 1 / span 2;
}

.assign-pending--fu-merge {
  color: #999999;
}

.col {
  box-sizing: border-box;
  padding-left: 14px;
  border-right: 1px solid #e0e0e0;
}

.col-service {
  display: block;
  padding-left: 0;
  align-self: stretch;
  min-height: 0;
  position: relative;
  overflow: hidden;
}

.svc-stack {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 100%;
  position: relative;
  padding: 0;
  margin-left: var(--care-svc-text-col-inset);
}

.card-body:not(.card-body--merged-split) .svc-stack {
  gap: var(--care-svc-text-row-gap);
}

.svc-name {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  text-align: left;
  margin: var(--care-svc-name-offset-top) 0 0;
  padding: 0;
}

.svc-icon-wrap {
  position: absolute;
  left: 0;
  top: var(--care-svc-icon-offset-top);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: var(--care-svc-icon-size);
  height: var(--care-svc-icon-size);
  padding: 0;
  background: #dff4c8;
  border-radius: 8px;
  border: 1px solid #4a7a2b;
}

.svc-icon-spacer {
  position: absolute;
  left: 0;
  top: var(--care-svc-icon-offset-top);
  flex-shrink: 0;
  width: var(--care-svc-icon-size);
  height: var(--care-svc-icon-size);
  box-sizing: border-box;
}

.svc-hex {
  width: 32px;
  height: 32px;
  object-fit: contain;
  display: block;
}

.svc-tags {
  margin-top: 0;
  font-size: 13px;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0 3px;
  color: unset;
}

.card-body:not(.card-body--merged-split) .svc-tags {
  position: static;
  left: auto;
  right: auto;
  top: auto;
  height: auto;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0 3px;
  line-height: var(--care-svc-tags-line-h);
}

.svc-tag-sep {
  display: inline-block;
  width: 1px;
  height: 13px;
  margin: 0 7px 0 6px;
  background: #d8dbe2;
  flex-shrink: 0;
  align-self: center;
}

.svc-tag {
  font-weight: 600;
}

.svc-tag-n,
.svc-tag-a,
.svc-tag-ic,
.svc-tag-i,
.svc-tag-u,
.svc-tag-b,
.svc-tag-plain,
.svc-tag-f {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
}

.svc-tag-n {
  color: #4a7a2b;
  -webkit-text-fill-color: #4a7a2b;
}

.svc-tag-a {
  color: #ffb407;
  -webkit-text-fill-color: #ffb407;
}

.svc-tag-ic {
  color: #e54848;
  -webkit-text-fill-color: #e54848;
}

.svc-tag-i {
  color: #e54848;
  -webkit-text-fill-color: #e54848;
}

.svc-tag-u,
.svc-tag-plain {
  color: #000000;
  -webkit-text-fill-color: #000000;
}

/* 检验码 P：设计稿 SF Pro Regular 14/20 #000 */
.svc-tag-p {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  -webkit-text-fill-color: #000000;
  text-align: left;
}

.svc-tag-f {
  color: #6a1b9a;
  -webkit-text-fill-color: #6a1b9a;
}

.svc-tag-b {
  color: #00aeef;
  -webkit-text-fill-color: #00aeef;
}

.svc-code {
  margin-top: 0;
  color: #000000;
  font-size: 13px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.card-body:not(.card-body--merged-split) .svc-code {
  position: static;
  left: auto;
  right: auto;
  top: auto;
  height: auto;
  line-height: var(--care-svc-tags-line-h);
}

.svc-time-stack {
  position: absolute;
  left: 0;
  right: 0;
  top: var(--care-svc-time-offset-top);
  height: var(--care-svc-time-line-h);
  margin-top: 0;
  display: flex;
  align-items: center;
}

.card-body:not(.card-body--merged-split) .svc-time-stack {
  position: static;
  left: auto;
  right: auto;
  top: auto;
  height: auto;
}

.svc-time-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.svc-time-fu-slot {
  margin-top: 4px;
}

.svc-time-status-ic {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  object-fit: contain;
  display: block;
}

.svc-time {
  margin-top: 0;
  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  -webkit-text-fill-color: #000000;
  text-align: left;
  white-space: nowrap;
}

/* Pending Schedule / Pending Reschedule：SF Pro Regular 14/20 #999，左对齐 */
.svc-time.svc-time--pending-schedule {
  font-family: 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: var(--care-svc-time-pending-color);
  -webkit-text-fill-color: var(--care-svc-time-pending-color);
  text-align: left;
  white-space: nowrap;
}

.fu-preferred-time-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  cursor: help;
  line-height: 0;
  pointer-events: auto;
}

.fu-preferred-time-btn:focus-visible {
  outline: 2px solid #000000;
  outline-offset: 2px;
  border-radius: 4px;
}

.svc-addr {
  margin-top: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: var(--care-svc-time-line-h);
  letter-spacing: 0;
  color: #000000;
  text-align: left;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

/* 单行订单地址：距白色 card-body 底 16px；过长时换行并撑高卡片 */
.card-body:not(.card-body--merged-split) .svc-addr {
  position: static;
  left: auto;
  right: auto;
  top: auto;
  margin-top: 0;
  min-height: var(--care-svc-time-line-h);
  height: auto;
}

.col-assign {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #888888;
  min-width: 0;
  position: relative;
  z-index: 3;
}

/* 跟进合并单 · 主单/跟进行服务人员：在各自格子内居中 */
.card-body--merged-split .merged-assign-top.col.col-assign {
  justify-content: center;
  box-sizing: border-box;
}

.assign-name {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.assign-name + .assign-ref-tip-host {
  margin-top: 8px;
}

.assign-name + .assign-ref {
  margin-top: 8px;
}

:deep(.assign-ref-tip-host.assign-name-tip-host) {
  display: inline-flex;
  width: auto;
  max-width: 100%;
}

.assign-ref {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  max-width: 100%;
  min-width: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  text-align: center;
}

.assign-ref-icon {
  width: 12px;
  height: 12px;
  display: block;
  flex-shrink: 0;
  object-fit: contain;
}

.assign-pending {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #999999;
  text-align: center;
}

.assign-pending-line {
  display: block;
  line-height: 20px;
}

.col-pay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.col-pay .price {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  text-align: left;
}

.pay-divider {
  width: 40px;
  height: 1px;
  background: #e0e0e0;
  margin: 8px 0;
}

.pay-method {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  text-align: left;
}

.pay-due-badge {
  box-sizing: border-box;
  margin-top: 6px;
  width: 93px;
  min-width: 93px;
  height: 20px;
  padding: 2px 8px;
  border-radius: 8px;
  background: #ffebeb;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui,
    sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #e54848;
  text-align: center;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.discount {
  color: #e53935;
  font-size: 12px;
  margin-top: 4px;
}

.col.col-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 14px;
  padding-right: 14px;
}

.col.col-detail .link {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  text-align: center;
  text-decoration: none;
  padding: 0;
  transition: none;
}

@media (hover: hover) {
  .col.col-detail .link:hover {
    background-color: transparent;
    color: #000000;
    text-decoration: none;
  }
}

.link {
  color: #000000;
  text-decoration: none;
  font-weight: 400;
}

.col-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  border-right: none;
  position: relative;
  z-index: 3;
  align-self: stretch;
  padding: 16px 0 16px 16px;
}

/* 主单 + 跟进合并卡：操作列距白色 card-body 顶 71px、底 70px */
.card-body--merged-split .col-actions {
  padding-top: 71px;
  padding-bottom: 70px;
}

.action {
  border: none;
  background: none;
  padding: 4px 0;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-height: 28px;
  box-sizing: border-box;
  text-align: left;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  cursor: pointer;
  text-decoration: none;
}

.action-ic {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
  pointer-events: none;
}

.action.disabled {
  color: #bbbbbb;
  cursor: default;
}

.action.disabled .action-ic {
  opacity: 0.35;
}

/** Send Messages：视觉常亮，点击不执行（见 onLineAction） */
.action.action--stub {
  color: #000000;
  cursor: default;
}

.action.action--stub .action-ic {
  opacity: 1;
}

/* box_75：分页区高 40，项间距 16，上下 margin 24px，整体靠右 */
.pager-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--care-row-gap);
  margin: 24px 0 24px auto;
  padding: 0;
  flex-wrap: wrap;
  width: auto;
  max-width: 100%;
  min-height: 40px;
  box-sizing: border-box;
}

.page-btn,
.nav-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 40px;
  min-width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: #f5f5fa;
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.nav-btn-ic {
  width: 16px;
  height: 16px;
  display: block;
  object-fit: contain;
  flex-shrink: 0;
}

.nav-btn-ic--prev {
  transform: scaleX(-1);
}

.page-btn {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0;
  color: #000000;
  text-align: center;
}

.page-btn.active {
  border: none;
  background: #000000;
  color: #ffffff;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0;
  text-align: center;
}

.nav-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.goto-label {
  margin-left: 14px;
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Text', 'SF Pro', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0;
  color: #000000;
  text-align: right;
}

.goto-input {
  box-sizing: border-box;
  width: 80px;
  height: 40px;
  padding: 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f5f6fb;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: #000000;
  -moz-appearance: textfield;
  appearance: textfield;
  outline: none;
  transition: border-color 0.15s ease;
}

.goto-input:focus {
  border-color: #666666;
}

.goto-input::-webkit-outer-spin-button,
.goto-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.goto-total {
  font-size: 13px;
  color: #666;
}

/* Add Notes — dialog (design: white modal on charcoal overlay) */
.note-modal-root {
  position: fixed;
  inset: 0;
  z-index: 12500;
  background: rgba(55, 55, 55, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family:
    system-ui,
    -apple-system,
    'Segoe UI',
    Roboto,
    Arial,
    sans-serif;
}

.note-modal {
  box-sizing: border-box;
  position: relative;
  width: min(530px, 100%);
  height: 380px;
  max-height: min(380px, calc(100vh - 48px));
  padding: 0 24px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e0e0e0;
  box-shadow: none;
  display: grid;
  grid-template-rows: 100px 200px 80px;
  overflow: hidden;
}

.note-modal-head {
  min-height: 0;
  padding: 0;
}

.note-modal-head-top {
  position: absolute;
  top: 24px;
  left: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
}

.note-modal-head h2 {
  margin: 0;
  min-width: 81px;
  width: max-content;
  height: 24px;
  flex-shrink: 0;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui,
    sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  white-space: nowrap;
}

.note-modal-x {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 1;
  padding: 4px;
  margin: -4px -4px 0 0;
  border-radius: 8px;
  flex-shrink: 0;
}

.note-modal-x-ic {
  width: 14px;
  height: 14px;
  display: block;
  object-fit: contain;
}

.note-modal-label {
  position: absolute;
  top: 64px;
  left: 24px;
  z-index: 1;
  margin: 0;
  min-width: 39px;
  width: max-content;
  height: 20px;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui,
    sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  white-space: nowrap;
}

.note-modal-body {
  min-height: 0;
}

.note-modal-textarea {
  width: min(482px, 100%);
  height: 200px;
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 8px 16px 16px 12px;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui,
    sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  resize: none;
  outline: none;
  display: block;
}

.note-modal-textarea::placeholder {
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui,
    sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #cccccc;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.note-modal-textarea:focus {
  border-color: #666666;
  box-shadow: none;
}

.note-modal-foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-height: 0;
  background: #fff;
}

.note-modal-btn {
  min-width: 96px;
  height: 42px;
  padding: 0 22px;
  border-radius: 999px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
}

.note-modal-btn-outline {
  box-sizing: border-box;
  width: 80px;
  min-width: 80px;
  height: 32px;
  padding: 6px 16px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #000000;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui,
    sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: right;
  font-style: normal;
  white-space: nowrap;
  cursor: pointer;
}

.note-modal-btn-outline:hover {
  background: #000000;
  color: #ffffff;
}

.note-modal-btn-solid {
  box-sizing: border-box;
  width: 80px;
  min-width: 80px;
  height: 32px;
  padding: 4px 14px 4px 16px;
  border-radius: 16px;
  background: #000000;
  border: 1px solid #000000;
  font-family: SFPro, SFPro, 'SF Pro', -apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui,
    sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  display: inline-flex;
  align-items: center;
  font-style: normal;
  white-space: nowrap;
  cursor: pointer;
}

.note-modal-btn-solid:hover {
  background: #484848;
  border-color: #222222;
}

.cod-overlay-root {
  position: fixed;
  inset: 0;
  z-index: 12400;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 24px 24px 40px;
}

.cod-overlay-shell {
  width: min(540px, 100%);
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.cod-overlay-shell :deep(.cod-panel) {
  flex: 1 1 auto;
  min-height: 0;
  max-height: 100%;
  height: 100%;
}

.order-delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.order-delete-modal-container {
  background-color: #ffffff;
  border-radius: 12px;
  width: 530px;
  min-height: 212px;
  height: auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}

.order-delete-modal-header {
  display: flex;
  justify-content: space-between;
  padding: 24px;
  flex-shrink: 0;
  box-sizing: border-box;
}

.order-delete-modal-title {
  font-size: 16px;
  font-weight: 700;
  font-family:
    SFPro,
    'SF Pro',
    -apple-system,
    BlinkMacSystemFont,
    system-ui,
    sans-serif;
  color: #000000;
  margin: 0;
}

.order-delete-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-delete-modal-close-ic {
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.order-delete-modal-body {
  flex: 1;
  box-sizing: border-box;
}

.order-delete-modal-message {
  font-size: 14px;
  font-weight: 400;
  font-family:
    SFPro,
    'SF Pro',
    -apple-system,
    BlinkMacSystemFont,
    system-ui,
    sans-serif;
  color: #000000;
  line-height: 20px;
  margin: 0 12px -24px 24px;
}

.order-delete-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 0 24px 24px 24px;
  flex-shrink: 0;
}

.order-delete-btn-no {
  width: 80px;
  height: 32px;
  padding: 0;
  border: 1px solid #000000;
  border-radius: 24px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  cursor: pointer;
}

.order-delete-btn-no:hover {
  background-color: #000000;
  color: #ffffff;
}

.order-delete-btn-yes {
  width: 80px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 24px;
  background-color: #000000;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-delete-btn-yes:hover {
  background-color: #484848;
}

.order-delete-btn-yes:disabled,
.order-delete-btn-no:disabled,
.order-delete-modal-close:disabled {
  cursor: not-allowed;
}

.order-delete-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: order-delete-spin 0.7s linear infinite;
}

@keyframes order-delete-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
